import { React } from "react";
import { Component } from "react";
import { createRef } from "react";
import axios from "axios";
import { axiosConfig } from "../../../config/utility";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  defaultShortlinkSettings,
  addSocialLinks,
  checkAvailability,
  addSharelink,
  addSharelinkNoLanding,
  getUserAboutMe,
  getServices,
  getUserImageLibrary,
  getSharelinkTestimonials,
  saveNewTestimonial,
  updateTestimonial,
  deleteTestimonial,
  listServiceTypes
} from "./../../../config/shortlink_api_calls";

import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";

import HelperClass from "./../../../config/helperClass";
import { tableLoaderListing } from "../../../components/ContentLoaders/table_loader_listing";
import { tableLoaderBlockImage } from "../../../components/ContentLoaders/table_loader_imageblock";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/FormLoader";
import { APP_LIVE_URL, API_URL } from "./../../../config/config";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";

import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import MutextField from "@material-ui/core/TextField";
//import { Editor } from "@tinymce/tinymce-react";
//import { CKEditor } from "@ckeditor/ckeditor5-react";
//import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import RichTextEditorComponent from "../../../components/Reseller/RichTextEditorComponent";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

import Radio from "@material-ui/core/Radio";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import dateFormat, { masks } from "dateformat";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

import { PhoneInput } from "react-international-phone";
import "react-international-phone/build/index.css";
import DataTable from "../../../components/Tables/DataTable";

import Select from "react-select";
const auth = new HelperClass();

class SharelinkSettings extends Component {
  constructor() {
    super();
    const addressComponents = [
      auth.getAddress(),
      auth.getCity(),
      auth.getState(),
      auth.getZip(),
      auth.getCountry(),
    ];
    const filteredAddressComponents = addressComponents.filter(
      (component) => component && component !== ""
    );
    const address = filteredAddressComponents.join(", ");
    this.state = {
      serviceData: [],
      bundleData: [],
      about_me_short: "",
      about_me: "",
      errorMessage: "",
      instagram_link: "",
      facebook_link: "",
      twitter_link: "",
      linkedin_link: "",
      youtube_link: "",
      successMessage: "",
      tableLoader: true,
      tableLoaderListing: true,
      tableLoaderBlockImage: true,
      tableLoaderBlockService: true,
      formLoader: true,
      add_picture: "",
      add_picture_name: "",
      add_images_type: "logo",
      add_image_title: "",
      logo: "",
      theme: "",
      theme_selected_icon: "",
      disabled: false,
      errorMessageEdit: "",
      successMessageEdit: "",
      docErrorMessage: "",
      docSuccessMessage: "",
      main_service_type: "service",
      status: "1",
      landing_page: "Yes",
      about_me_settings: true,
      contact_settings: true,
      social_settings: true,
      picture: "",
      pictureName: "",
      select_banner: false,
      selected_banner: "",
      bannerData: [],
      title: "",
      logo_view: "",
      imageData: [],
      seo_settings: false,
      meta_description: "",
      meta_title: auth.getName() + " - " + auth.getCompName(),
      contact_address: address,
      contact_email: auth.getEmail(),
      contact_phone: auth.getPhone(),
      select_logo: false,
      select_avatar: false,
      selected_logo: "",
      selected_avatar: "",
      avatarData: [],
      logoData: [],
      themesList: [],
      link_identifier: "",
      link_available: "0",
      loadingButton: false,
      selected_service: [],
      selected_bundle: [],
      availability_button: false,
      sharelink_limit: auth.getSharelinkLimit(),
      sharelink_added: 0,
      contact_email_error: "",
      contact_phone_error: "",
      contact_address_error: "",
      instagram_link_error: "",
      facebook_link_error: "",
      twitter_link_error: "",
      linkedin_link_error: "",
      youtube_link_error: "",
      isEditorReady: false,
      brightness: 100,
      showBrightnessRange: false,

      selected_avatar2: "",
      avatarData2: [],

      currentPageLogo: 1,
      logosPerPage: 3,
      currentPageAvatar: 1,
      avatarsPerPage: 3,
      currentPageAvatar2: 1,
      avatarsPerPage2: 3,
      currentPageBanner: 1,
      bannersPerPage: 3,
      isAddingTestimonial: false,
      testimonials: [],
      selectedTestimonials: [],
      testimonial_name: "",
      testimonial_title: "",
      testimonial_comment: "",
      testimonial_img: "",
      selectedImageName: "",
      all_service_types: [],
      selected_service_types: [],
      service_type_id: [],
      testimonialErrors: {
        nameError: "",
        titleError: "",
        commentError: "",
      },
      save_testimonial_btn_disable: false,
      columnTestimonials: [
        { name: "Id", options: { display: false } },
        {
          name: "Select",
          options: {
            customBodyRender: (value, tableMeta) => {
              return (
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={this.handleTestimonialSelection(
                        tableMeta.rowData[0]
                      )}
                      color="primary"
                      checked={this.state.selectedTestimonials.includes(
                        tableMeta.rowData[0]
                      )}
                    />
                  }
                />
              );
            },
          },
        },

        { name: "Name" },
        { name: "Title" },
        { name: "Comment" },
        {
          name: "Image",
          options: {
            customBodyRender: (value, tableMeta) => {
              return (
                <div>
                  {tableMeta.rowData[5] && tableMeta.rowData[5] !== "" ? (
                    <img
                      style={{
                        height: "50px",
                        width: "auto",
                      }}
                      src={`${APP_LIVE_URL}files_data/sharelinks/${tableMeta.rowData[5]}`}
                      alt="Testimonial Image"
                    />
                  ) : (
                    <span>-</span>
                  )}
                </div>
              );
            },
          },
        },
        {
          name: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              return (
                <div>
                  <div
                    className="nk-tb-col nk-tb-col-tools"
                    style={{ padding: "0px" }}
                  >
                    <ul className="nk-tb-actions gx-1">
                      <li>
                        <div className="drodown">
                          <a
                            href="#"
                            className="dropdown-toggle btn btn-icon btn-outline-light"
                            data-toggle="dropdown"
                          >
                            <em className="icon ni ni-more-h"></em>
                          </a>
                          <div className="dropdown-menu dropdown-menu-right">
                            <ul className="link-list-opt no-bdr">
                              <li>
                                <a
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  onClick={() => this.editTestimonial(value)}
                                  title="Edit Testimonial"
                                  style={{ cursor: "pointer" }}
                                >
                                  <em className="icon ni ni-edit"></em>
                                  <span>Edit Testimonial</span>
                                </a>
                              </li>
                              <li>
                                <a
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  onClick={() => this.deleteTestimonial(value)}
                                  title="Delete Testimonial"
                                  style={{ cursor: "pointer" }}
                                >
                                  <em className="icon ni ni-trash-empty"></em>
                                  <span>Delete Testimonial</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            },
          },
        },
      ],
    };
    this.cropperRef = createRef();
    this.phoneInputRef = createRef();
  }
  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };
  serviceSigning = async (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  async componentDidMount() {
    const servicesResponce = await defaultShortlinkSettings(
      auth.getAccount(),
      auth.getToken()
    );
    let logo_array = [];
    let avatar_array = [];
    let banner_array = [];
    let avatar2_array = [];
    console.log(
      "servicesResponce.data.sharelink_limit: " +
        servicesResponce.data.sharelink_limit +
        " " +
        this.state.sharelink_added
    );
    if (servicesResponce.data.sharelink_limit) {
      if (
        servicesResponce.data.sharelink_limit <=
        servicesResponce.data.sharelink_added
      ) {
        window.location.replace("/sharelinks");
      }
    }
    if (servicesResponce.data.images) {
      logo_array = this.groupBy(servicesResponce.data.images, "logo");
    }
    if (servicesResponce.data.images) {
      avatar_array = this.groupBy(servicesResponce.data.images, "image");
    }
    if (servicesResponce.data.images) {
      avatar2_array = this.groupBy(servicesResponce.data.images, "image2");
    }
    if (servicesResponce.data.images) {
      banner_array = this.groupBy(servicesResponce.data.images, "banner");
    }
    console.log("defaultSharelinkSettings: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableLoaderBlockImage: false,
        isEditorReady: true,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      // if(contact_email_error !== "" || contact_phone_error !== "" || contact_address_error !== ""){
      //   this.setState({
      //     contact_settings_error : true,
      //   })
      // }

      // if(instagram_link_error !== "" || facebook_link_error !== "" || twitter_link_error !== "" || linkedin_link_error !== "" || youtube_link_error !== ""){
      //   this.setState({
      //     social_settings_error : true,
      //   })
      // }

      this.setState({
        about_me_short: servicesResponce.data.data[0]["about_me_short"],
        meta_description: "",
        about_me: servicesResponce.data.data[0]["about_me"],
        instagram_link: servicesResponce.data.data[0]["instagram_link"],
        facebook_link: servicesResponce.data.data[0]["facebook_link"],
        twitter_link: servicesResponce.data.data[0]["twitter_link"],
        linkedin_link: servicesResponce.data.data[0]["linkedin_link"],
        youtube_link: servicesResponce.data.data[0]["youtube_link"],
        setting_id: servicesResponce.data.data[0]["id"],
        logoData: logo_array,
        avatarData: avatar_array,
        bannerData: banner_array,
        avatarData2: avatar2_array,
        selected_avatar2: avatar2_array[0]?.id || "",
        selected_logo: logo_array[0].id,
        selected_avatar: avatar_array[0].id,
        selected_banner: banner_array[0].id,
        themesList: servicesResponce.data.themes,
        tableLoaderBlockImage: false,
        isEditorReady: true,
      });
    } else {
      this.setState({
        tableLoaderBlockImage: false,
        isEditorReady: true,
      });
      //window.location.replace("/error");
    }
    this.getTestimonialsLibrary();
  }

  getTableData() {
    return this.state.testimonials.map((testimonial, index) => ({
      Id: testimonial.id,
      Name: testimonial.name,
      Title: testimonial.title,
      Comment: testimonial.comment,
      Image: testimonial.image_name,
      Actions: index,
    }));
  }

  handleFocus = () => {
    // Move cursor to the end of the input value
    const input = this.phoneInputRef.current;
    if (input) {
      const value = input.value;
      input.setSelectionRange(value.length, value.length);
    }
  };

  getServices = async () => {
    const getResponce = await getServices(auth.getAccount(), auth.getToken());
    console.log("getServices: ", getResponce.data);
    if (
      getResponce.data.status === 403 ||
      getResponce.data.errors === "authentication missing" ||
      getResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (getResponce.data.status === 404) {
      this.setState({
        tableLoaderBlockService: false,
      });
      //window.location.replace("/error");
    } else if (
      getResponce.data.status === 200 &&
      getResponce.data.message === "success"
    ) {
      this.setState({
        serviceData: getResponce.data.data,
        bundleData: getResponce.data.bundleList,
        tableLoaderBlockService: false,
      });
      await this.getServiceTypes();
    } else {
      this.setState({
        tableLoaderBlockService: false,
      });
      //window.location.replace("/error");
    }
  };

  getServiceTypes = async () => {
    const servicesResponce = await listServiceTypes(
      auth.getAccount(),
      auth.getToken()
    );

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let all_clients = [];
      if (servicesResponce.data.data && servicesResponce.data.data.length > 0) {
        for (let i = 0; i < servicesResponce.data.data.length; i++) {
          let newArr = {
            label: servicesResponce.data.data[i]["product_title"],
            value: servicesResponce.data.data[i]["product_id"],
          };
          all_clients.push(newArr);
        }
      }
      this.setState({
        all_service_types: all_clients,
      });
    } else {
      this.setState({
        all_service_types: [],
      });
    }
  };

  handleChangeSearch = async (changed_value) => { 
    this.setState({
      tableLoaderBlockService: true,
    });
    const delay = 1000;

    if (changed_value) {
      const selectedIds = changed_value.map((item) => item.value);

      setTimeout(() => {
        this.setState(
          {
            service_type_id: selectedIds,
            selected_service_types: changed_value,
            tableLoaderBlockService: false,
          },
          () => {
            let services = this.state.serviceData.filter((service) =>
              selectedIds.includes(service.product_id)
            );
            const filteredSelectedServices = this.state.selected_service.filter(serviceId =>
              services.some(service => service.id === serviceId)
            );

            this.setState({
              selected_service: filteredSelectedServices
            });
          }
        );
      }, delay);
    } else {
      setTimeout(() => {
        this.setState(
          {
            service_type_id: [],
            selected_service_types: [],
            selected_service: [],
            tableLoaderBlockService: false,
          },
          () => {
            let services = [];
          }
        );
      }, delay);
    }
  };

  groupBy = (arr, property) => {
    let intArray = arr;
    let evenArray = [];
    intArray.map((x) => {
      if (x.images_type === property) {
        evenArray.push(x);
      }
    });

    return evenArray;
  };

  handlePageChange = (type, direction) => {
    const {
      logoData,
      avatarData,
      avatarData2,
      bannerData,
      logosPerPage,
      avatarsPerPage,
      avatarsPerPage2,
      bannersPerPage,
    } = this.state;

    let newPage;
    switch (type) {
      case "logo":
        newPage =
          direction === "prev"
            ? this.state.currentPageLogo - 1
            : this.state.currentPageLogo + 1;
        this.setState({
          currentPageLogo: Math.max(
            1,
            Math.min(newPage, Math.ceil(logoData.length / logosPerPage))
          ),
        });
        break;
      case "avatar":
        newPage =
          direction === "prev"
            ? this.state.currentPageAvatar - 1
            : this.state.currentPageAvatar + 1;
        this.setState({
          currentPageAvatar: Math.max(
            1,
            Math.min(newPage, Math.ceil(avatarData.length / avatarsPerPage))
          ),
        });
        break;
      case "avatar2":
        newPage =
          direction === "prev"
            ? this.state.currentPageAvatar2 - 1
            : this.state.currentPageAvatar2 + 1;
        this.setState({
          currentPageAvatar2: Math.max(
            1,
            Math.min(newPage, Math.ceil(avatarData2.length / avatarsPerPage2))
          ),
        });
        break;
      case "banner":
        newPage =
          direction === "prev"
            ? this.state.currentPageBanner - 1
            : this.state.currentPageBanner + 1;
        this.setState({
          currentPageBanner: Math.max(
            1,
            Math.min(newPage, Math.ceil(bannerData.length / bannersPerPage))
          ),
        });
        break;
      default:
        break;
    }
  };

  addTestimonial = () => {
    let randomNumber = Math.floor(Math.random() * 1000000);
    this.setState({
      isAddingTestimonial: true,
      isEditing: false,
      editingIndex: null,
      testimonial_name: "",
      testimonial_title: "",
      testimonial_comment: "",
      testimonial_img: "",
      selectedImageName: "",
      testimonialErrors: {},
      testimonial_id: randomNumber,
    });
  };

  editTestimonial = (index) => {
    const testimonial = this.state.testimonials[index];
    this.setState({
      isAddingTestimonial: true,
      isEditing: true,
      editingIndex: index,
      testimonial_name: testimonial.name,
      testimonial_title: testimonial.title,
      testimonial_comment: testimonial.comment,
      testimonial_img: testimonial.image_name,
      testimonial_id: testimonial.id,
      testimonialErrors: {},
    });
  };

  saveTestimonial = async () => {
    const {
      isEditing,
      editingIndex,
      testimonial_name,
      testimonial_title,
      testimonial_comment,
      testimonials,
      testimonial_img,
      testimonial_id,
    } = this.state;
    let errors = {};
    if (!testimonial_name) errors.nameError = "Name is required";
    if (!testimonial_title) errors.titleError = "Title is required";
    if (!testimonial_comment) errors.commentError = "Comment is required";

    if (Object.keys(errors).length > 0) {
      this.setState({ testimonialErrors: errors });
      return;
    }
    if (isEditing) {
      const currentTestimonial = testimonials[editingIndex];
      const editedTestimonial = {
        id: currentTestimonial.id,
        name: testimonial_name,
        title: testimonial_title,
        comment: testimonial_comment,
        image_name: testimonial_img,
      };
      await this.updateTestimonial(
        currentTestimonial.id,
        testimonial_name,
        testimonial_title,
        testimonial_comment,
        testimonial_img
      );
      const updatedTestimonials = testimonials.map((item, index) =>
        index === editingIndex ? editedTestimonial : item
      );
      this.setState({
        testimonials: updatedTestimonials,
        isAddingTestimonial: false,
        isEditing: false,
        editingIndex: null,
        testimonial_name: "",
        testimonial_title: "",
        testimonial_comment: "",
        testimonial_img: "",
        selectedImageName: "",
        testimonialErrors: {},
      });
    } else {
      const newTestimonial = {
        name: testimonial_name,
        title: testimonial_title,
        comment: testimonial_comment,
        image_name: testimonial_img,
        id: testimonial_id,
      };
      await this.saveNewTestimonial(
        testimonial_id,
        testimonial_name,
        testimonial_title,
        testimonial_comment,
        testimonial_img
      );
      this.setState((prevState) => ({
        testimonials: [...prevState.testimonials, newTestimonial],
        isAddingTestimonial: false,
        testimonial_name: "",
        testimonial_title: "",
        testimonial_comment: "",
        testimonial_img: "",
        selectedImageName: "",
        testimonialErrors: {},
      }));
    }
  };

  saveNewTestimonial = async (
    testimonial_id,
    testimonial_name,
    testimonial_title,
    testimonial_comment,
    testimonial_img
  ) => {
    try {
      const saveResponse = await saveNewTestimonial(
        auth.getAccount(),
        auth.getToken(),
        testimonial_name,
        testimonial_title,
        testimonial_comment,
        testimonial_img,
        testimonial_id
      );
      if (
        saveResponse.data.status === 403 ||
        saveResponse.data.errors === "authentication missing" ||
        saveResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        saveResponse.data.status === 200 &&
        saveResponse.data.message === "success"
      ) {
        this.setState({
          uErrorMessage: "",
          uSuccessMessage: "Testimonial added successfully.",
          disabled: false,
        });
      } else {
        this.setState({
          uErrorMessage: "There is some error while adding the testimonial.",
          uSuccessMessage: "",
          disabled: false,
        });
      }
      setTimeout(() => {
        this.setState({ uSuccessMessage: "", uErrorMessage: "" });
      }, 3000);
    } catch (error) {
      console.error("Error while saving testimonial:", error);
      this.setState({
        uErrorMessage: "An unexpected error occurred.",
        uSuccessMessage: "",
        disabled: false,
      });
    }
  };

  updateTestimonial = async (
    testimonial_id,
    testimonial_name,
    testimonial_title,
    testimonial_comment,
    testimonial_img
  ) => {
    try {
      const saveResponse = await updateTestimonial(
        auth.getAccount(),
        auth.getToken(),
        testimonial_name,
        testimonial_title,
        testimonial_comment,
        testimonial_img,
        testimonial_id
      );
      if (
        saveResponse.data.status === 403 ||
        saveResponse.data.errors === "authentication missing" ||
        saveResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        saveResponse.data.status === 200 &&
        saveResponse.data.message === "success"
      ) {
        this.setState({
          uErrorMessage: "",
          uSuccessMessage: "Testimonials updated successfully.",
          disabled: false,
        });
      } else {
        this.setState({
          uErrorMessage: "There is some error while updating the testimonials.",
          uSuccessMessage: "",
          disabled: false,
        });
      }

      setTimeout(() => {
        this.setState({ uSuccessMessage: "", uErrorMessage: "" });
      }, 3000);
    } catch (error) {
      console.error("Error while saving testimonial:", error);
      this.setState({
        uErrorMessage: "An unexpected error occurred.",
        uSuccessMessage: "",
        disabled: false,
      });
    }
  };

  deleteTestimonial = async (index) => {
    const currentTestimonial = this.state.testimonials[index];
    try {
      const saveResponse = await deleteTestimonial(
        auth.getAccount(),
        auth.getToken(),
        currentTestimonial.id
      );
      if (
        saveResponse.data.status === 403 ||
        saveResponse.data.errors === "authentication missing" ||
        saveResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        saveResponse.data.status === 200 &&
        saveResponse.data.message === "success"
      ) {
        const updatedTestimonials = this.state.testimonials.filter(
          (_, i) => i !== index
        );
        this.setState({
          testimonials: updatedTestimonials,
          uErrorMessage: "",
          uSuccessMessage: "Testimonial Deleted Successfully.",
          disabled: false,
        });
      } else {
        this.setState({
          uErrorMessage: "There is some error while deleting the testimonial.",
          uSuccessMessage: "",
          disabled: false,
        });
      }
      setTimeout(() => {
        this.setState({ uSuccessMessage: "", uErrorMessage: "" });
      }, 3000);
    } catch (error) {
      console.error("Error while saving testimonial:", error);
      this.setState({
        uErrorMessage: "An unexpected error occurred.",
        uSuccessMessage: "",
        disabled: false,
      });
    }
  };

  handleTestimonialImageChange = (event) => {
    const file = event.target.files[0];
    this.setState({
      save_testimonial_btn_disable: true,
    });
    const formData = new FormData();
    formData.append("token", process.env.REACT_APP_API_TOKEN);
    formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);
    formData.append("file", file);

    axios
      .post(
        process.env.REACT_APP_API_URL + "uploads/upload_testimonial_image",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "http://localhost:3000",
            "Access-Control-Allow-Credentials": true,
          },
        }
      )
      .then((res) => {
        if (
          res.data.status === 403 ||
          res.data.errors === "authentication missing" ||
          res.data.errors === "jwt expired"
        ) {
          auth.logout();
        } else if (res.data.status === 404 && res.data.error === "error") {
          this.setState({
            docSuccessMessage: "",
            docErrorMessage: res.data.message,
            save_testimonial_btn_disable: false,
          });
        } else if (res.data.status === 200 && res.data.message === "success") {
          this.setState({
            testimonial_img: res.data.img_url,
            selectedImageName: file.name,
            save_testimonial_btn_disable: false,
          });
        }
      })
      .catch((error) => {
        console.error("Error uploading image: ", error);
        this.setState({
          docErrorMessage: "Error uploading image. Please try again later.",
        });
      });
  };

  saveSharelink = async () => {
    const {
      theme,
      selected_logo,
      selected_avatar,
      selected_banner,
      title,
      link_identifier,
      link_available,
      instagram_link,
      facebook_link,
      twitter_link,
      linkedin_link,
      youtube_link,
      about_me_short,
      about_me,
      meta_description,
      meta_title,
      contact_address,
      contact_email,
      contact_phone,
      status,
      main_service_type,
      landing_page,
      contact_email_error,
      contact_phone_error,
      contact_address_error,
      instagram_link_error,
      facebook_link_error,
      twitter_link_error,
      linkedin_link_error,
      youtube_link_error,
      selected_avatar2,
      testimonials,
    } = this.state;

    this.setState({
      loadingButton: true,
    });

    let is_validated = true;

    let about_me_settings = "0";
    if (this.state.about_me_settings === true) {
      about_me_settings = "1";
    }

    let contact_settings = "0";
    if (this.state.contact_settings === true) {
      contact_settings = "1";
    }

    let social_settings = "0";
    if (this.state.social_settings === true) {
      social_settings = "1";
    }

    if (
      theme === "" &&
      selected_logo === "" &&
      selected_avatar === "" &&
      //selected_avatar2 === "" &&
      selected_banner === "" &&
      title === "" &&
      link_identifier === ""
    ) {
      is_validated = false;
    }

    if (link_available !== "1") {
      is_validated = false;
    }

    if (
      contact_email_error !== "" ||
      contact_phone_error !== "" ||
      contact_address_error !== "" ||
      instagram_link_error !== "" ||
      facebook_link_error !== "" ||
      twitter_link_error !== "" ||
      linkedin_link_error !== "" ||
      youtube_link_error !== ""
    ) {
      is_validated = false;
    }

    /*if (main_service_type === "service") {
      if (!this.state.selected_service) {
        is_validated = false;
      }
    } else if (main_service_type === "bundle") {
      if (!this.state.selected_bundle) {
        is_validated = false;
      }
    }*/
    const testimonialsToSave = this.getSelectedTestimonials();
    if (is_validated) {
      const addResponce = await addSharelink(
        auth.getAccount(),
        auth.getToken(),
        theme,
        selected_logo,
        selected_avatar,
        selected_banner,
        title,
        link_identifier,
        link_available,
        instagram_link,
        facebook_link,
        twitter_link,
        linkedin_link,
        youtube_link,
        about_me_short,
        this.state.about_me,
        meta_description,
        meta_title,
        contact_address,
        contact_email,
        contact_phone,
        status,
        about_me_settings,
        contact_settings,
        social_settings,
        this.state.selected_service,
        main_service_type,
        this.state.selected_bundle,
        landing_page,
        selected_avatar2,
        testimonialsToSave
      );

      console.log("addSharelink: ", addResponce.data);

      if (
        addResponce.data.status === 403 ||
        addResponce.data.errors === "authentication missing" ||
        addResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        addResponce.data.status === 404 &&
        addResponce.data.message === "not_available"
      ) {
        // window.location.replace("/error");

        this.setState({
          errorMessage:
            "Custom link ID is not available. Please choose new ID.",
          successMessage: "",
          disabled: false,
        });
      } else if (
        addResponce.data.status === 200 &&
        addResponce.data.message === "success"
      ) {
        this.setState({
          errorMessage: "",
          successMessage: "Sharelink added successfully.",
          disabled: false,
          logo: "",
          avatar: "",
          theme: "none",
          title: "",
          link_identifier: "",
          link_available: "0",
        });
        setTimeout(() => {
          window.location.replace("/sharelinks");
        }, 3000);
      } else {
        this.setState({
          errorMessage: "There is some error while adding the sharelink.",
          successMessage: "",
          disabled: false,
        });
        //window.location.replace("/error");
      }
    } else {
      this.setState({
        errorMessage: "Please enter the required fields.",
        successMessage: "",
      });
    }
    document
      .getElementById("start_container")
      ?.scrollIntoView({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      this.setState({
        successMessage: "",
        errorMessage: "",
        loadingButton: false,
      });
    }, 5000);
  };

  saveSharelinkNoLanding = async () => {
    const { title, link_identifier, link_available, status, landing_page } =
      this.state;

    this.setState({
      loadingButton: true,
    });

    let is_validated = true;

    if (title === "" && link_identifier === "") {
      is_validated = false;
    }

    if (link_available !== "1") {
      is_validated = false;
    }

    if (is_validated) {
      const addResponce = await addSharelinkNoLanding(
        auth.getAccount(),
        auth.getToken(),
        title,
        link_identifier,
        link_available,
        status,
        landing_page
      );

      console.log("saveSharelinkNoLanding: ", addResponce.data);

      if (
        addResponce.data.status === 403 ||
        addResponce.data.errors === "authentication missing" ||
        addResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        addResponce.data.status === 404 &&
        addResponce.data.message === "not_available"
      ) {
        // window.location.replace("/error");

        this.setState({
          errorMessage:
            "Custom link ID is not available. Please choose new ID.",
          successMessage: "",
          disabled: false,
        });
      } else if (
        addResponce.data.status === 200 &&
        addResponce.data.message === "success"
      ) {
        this.setState({
          errorMessage: "",
          successMessage: "Sharelink added successfully.",
          disabled: false,
          logo: "",
          avatar: "",
          theme: "",
          title: "",
          link_identifier: "",
          link_available: "0",
        });
        setTimeout(() => {
          window.location.replace("/sharelinks");
        }, 3000);
      } else {
        this.setState({
          errorMessage: "There is some error while adding the sharelink.",
          successMessage: "",
          disabled: false,
        });
        //window.location.replace("/error");
      }
    } else {
      this.setState({
        errorMessage: "Please enter the required fields.",
        successMessage: "",
      });
    }
    document
      .getElementById("start_container")
      ?.scrollIntoView({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      this.setState({
        successMessage: "",
        errorMessage: "",
        loadingButton: false,
      });
    }, 5000);
  };

  saveAndPreview = async () => {
    const {
      theme,
      selected_logo,
      selected_avatar,
      selected_banner,
      title,
      link_identifier,
      link_available,
      instagram_link,
      facebook_link,
      twitter_link,
      linkedin_link,
      youtube_link,
      about_me_short,
      about_me,
      meta_description,
      meta_title,
      contact_address,
      contact_email,
      contact_phone,
      status,
      main_service_type,
      landing_page,
      contact_email_error,
      contact_phone_error,
      contact_address_error,
      instagram_link_error,
      facebook_link_error,
      twitter_link_error,
      linkedin_link_error,
      youtube_link_error,
      selected_avatar2,
    } = this.state;

    this.setState({
      loadingButton: true,
    });

    let is_validated = true;

    let about_me_settings = "0";
    if (this.state.about_me_settings === true) {
      about_me_settings = "1";
    }

    let contact_settings = "0";
    if (this.state.contact_settings === true) {
      contact_settings = "1";
    }

    let social_settings = "0";
    if (this.state.social_settings === true) {
      social_settings = "1";
    }

    if (
      theme === "" &&
      selected_logo === "" &&
      selected_avatar === "" &&
      selected_banner === "" &&
      title === "" &&
      link_identifier === ""
    ) {
      is_validated = false;
    }

    if (link_available !== "1") {
      is_validated = false;
    }

    if (
      contact_email_error !== "" ||
      contact_phone_error !== "" ||
      contact_address_error !== "" ||
      instagram_link_error !== "" ||
      facebook_link_error !== "" ||
      twitter_link_error !== "" ||
      linkedin_link_error !== "" ||
      youtube_link_error !== ""
    ) {
      is_validated = false;
    }

    /*if (!this.state.selected_service) {
      is_validated = false;
    }*/

    if (is_validated) {
      const addResponce = await addSharelink(
        auth.getAccount(),
        auth.getToken(),
        theme,
        selected_logo,
        selected_avatar,
        selected_banner,
        title,
        link_identifier,
        link_available,
        instagram_link,
        facebook_link,
        twitter_link,
        linkedin_link,
        youtube_link,
        about_me_short,
        this.state.about_me,
        meta_description,
        meta_title,
        contact_address,
        contact_email,
        contact_phone,
        status,
        about_me_settings,
        contact_settings,
        social_settings,
        this.state.selected_service,
        main_service_type,
        this.state.selected_bundle,
        landing_page,
        selected_avatar2
      );

      //console.log("contact_phone: ", addResponce.data);

      if (
        addResponce.data.status === 403 ||
        addResponce.data.errors === "authentication missing" ||
        addResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        addResponce.data.status === 404 &&
        addResponce.data.message === "not_available"
      ) {
        // window.location.replace("/error");

        this.setState({
          errorMessage:
            "Custom link ID is not available. Please choose new ID.",
          successMessage: "",
          disabled: false,
        });
      } else if (
        addResponce.data.status === 200 &&
        addResponce.data.message === "success"
      ) {
        this.setState({
          errorMessage: "",
          successMessage:
            "Sharelink added successfully. You will be redirected to the sharelink preview.",
          disabled: false,
          loadingButton: false,
          logo: "",
          avatar: "",
          theme: "none",
          title: "",
          link_identifier: "",
          link_available: "0",
        });
        document
          .getElementById("start_container")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          window.open(addResponce.data.link, "_blank", "noopener,noreferrer");
        }, 3000);
      } else {
        this.setState({
          errorMessage: "There is some error while adding the sharelink.",
          successMessage: "",
          disabled: false,
        });
        //window.location.replace("/error");
      }
    } else {
      this.setState({
        errorMessage: "Please enter the required fields.",
        successMessage: "",
      });
    }
    document
      .getElementById("start_container")
      ?.scrollIntoView({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      this.setState({
        successMessage: "",
        errorMessage: "",
        loadingButton: false,
      });
    }, 5000);
  };

  formSaveSocial = async () => {
    window.scrollTo(0, 0);
    const {
      instagram_link,
      facebook_link,
      twitter_link,
      linkedin_link,
      youtube_link,
    } = this.state;

    const saveResponce = await addSocialLinks(
      auth.getAccount(),
      auth.getToken(),
      instagram_link,
      facebook_link,
      twitter_link,
      linkedin_link,
      youtube_link
    );
    //console.log("ADD Social: ", saveResponce.data);
    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 404 &&
      saveResponce.data.message === "fail" &&
      saveResponce.data.note !== ""
    ) {
      // window.location.replace("/error");
      this.setState({
        errorMessage: saveResponce.data.note,
        successMessage: "",
        disabled: false,
      });
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({
        errorMessage: "",
        successMessage: "Social media links added successfully.",
        disabled: false,
      });
    } else {
      this.setState({
        errorMessage: saveResponce.data.message,
        successMessage: "",
        disabled: false,
      });
      //window.location.replace("/error");
    }
    setTimeout(() => {
      this.setState({ successMessage: "", errorMessage: "" });
    }, 5000);
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  hide_messages = () => {
    this.setState({
      errorMessage: "",
      successMessage: "",
      errorMessageEdit: "",
      successMessageEdit: "",
      disabled: false,
    });
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;

    const { name } = target;

    if (name === "contact_email") {
      this.handleContactDetailValidation(name, value);
    }

    if (name === "contact_phone") {
      this.handleContactDetailValidation(name, value.toString());
    }

    if (name === "contact_address") {
      this.handleContactDetailValidation(name, value);
    }

    if (name === "instagram_link") {
      this.handleSocialLinkValidation(name, value);
    }

    if (name === "facebook_link") {
      this.handleSocialLinkValidation(name, value);
    }

    if (name === "twitter_link") {
      this.handleSocialLinkValidation(name, value);
    }

    if (name === "linkedin_link") {
      this.handleSocialLinkValidation(name, value);
    }

    if (name === "youtube_link") {
      this.handleSocialLinkValidation(name, value);
    }

    if (name === "add_images_type") {
      const inputElement = document.getElementById("add_picture");
      if (inputElement) {
        const selectedFile = inputElement.files[0];
        if (selectedFile) {
          inputElement.value = null;
          this.setState({
            docErrorMessage: "",
            add_picture: "",
            add_picture_name: "",
          });
        }
      }
    }

    if (name === "contact_settings") {
      if (!value) {
        this.setState({
          contact_email_error: "",
          contact_phone_error: "",
          contact_address_error: "",
        });
      } else {
        let contact_email = this.state.contact_email;
        let contact_phone = this.state.contact_phone
          ? this.state.contact_phone.toString()
          : "";
        let contact_address = this.state.contact_address
          ? this.state.contact_address.toString()
          : "";

        if (typeof contact_email === "string" && contact_email.trim() !== "") {
          this.handleContactDetailValidation("contact_email", contact_email);
        }

        if (typeof contact_phone === "string" && contact_phone.trim() !== "") {
          this.handleContactDetailValidation("contact_phone", contact_phone);
        }

        if (
          typeof contact_address === "string" &&
          contact_address.trim() !== ""
        ) {
          this.handleContactDetailValidation(
            "contact_address",
            contact_address
          );
        }
      }
    }

    if (name === "social_settings") {
      if (!value) {
        this.setState({
          instagram_link_error: "",
          facebook_link_error: "",
          twitter_link_error: "",
          linkedin_link_error: "",
          youtube_link_error: "",
        });
      } else {
        this.handleSocialLinkValidation(
          "instagram_link",
          this.state.instagram_link
        );
        this.handleSocialLinkValidation(
          "facebook_link",
          this.state.facebook_link
        );
        this.handleSocialLinkValidation(
          "twitter_link",
          this.state.twitter_link
        );
        this.handleSocialLinkValidation(
          "linkedin_link",
          this.state.linkedin_link
        );
        this.handleSocialLinkValidation(
          "youtube_link",
          this.state.youtube_link
        );
      }
    }

    this.setState({
      [name]: value,
    });
  };

  handleChangeCheckbox = async (event) => {
    const { target } = event;
    const value = target.type === "radio" ? target.value : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
      isBlocking: false,
    });

    console.log("handleChangeCheckbox:", name + " " + value);
  };

  handleChangeRadio = async (event) => {
    const { target } = event;
    const value = target.type === "radio" ? target.checked : target.value;

    const { name } = target;

    if (name === "select_logo") {
      this.setState({
        [name]: value,
        selected_logo: target.value,
      });
    }
    if (name === "select_avatar") {
      this.setState({
        [name]: value,
        selected_avatar: target.value,
      });
    }
    if (name === "select_avatar2") {
      this.setState({
        [name]: value,
        selected_avatar2: target.value,
      });
    }
    if (name === "select_banner") {
      this.setState({
        [name]: value,
        selected_banner: target.value,
      });
    }
    //console.log("handleChangeRadio:", name + " " + value + " " + target.value);
  };

  setAvatar2 = (id) => {
    this.setState({
      selected_avatar2: id,
    });
  };
  setAvatar2Class = (id) => {
    if (this.state.selected_avatar2 === id) {
      return "read active";
    } else {
      return "read";
    }
  };

  setAvatar2ClassMain = (id) => {
    if (this.state.selected_avatar2 === id) {
      return "pricingTable active2";
    } else {
      return "pricingTable";
    }
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mmmm dS, yyyy");
  };

  setTheme = (id) => {
    //console.log("Theme: ", id);
    this.setState({
      theme: id,
    });
  };

  setLogo = (id) => {
    //console.log("Logo: ", id);
    this.setState({
      selected_logo: id,
    });
  };

  setAvatar = (id) => {
    //console.log("Avatar: ", id);
    this.setState({
      selected_avatar: id,
    });
  };

  setThemeClass = (id) => {
    if (this.state.theme === id) {
      return "read active";
    } else {
      return "read";
    }
  };

  setThemeClassMain = (id) => {
    if (this.state.theme === id) {
      return "pricingTable active2";
    } else {
      return "pricingTable";
    }
  };

  setLogoClass = (id) => {
    if (this.state.selected_logo === id) {
      return "read active";
    } else {
      return "read";
    }
  };

  setLogoClassMain = (id) => {
    if (this.state.selected_logo === id) {
      return "pricingTable active2";
    } else {
      return "pricingTable";
    }
  };

  setAvatarClass = (id) => {
    if (this.state.selected_avatar === id) {
      return "read active";
    } else {
      return "read";
    }
  };

  setAvatarClassMain = (id) => {
    if (this.state.selected_avatar === id) {
      return "pricingTable active2";
    } else {
      return "pricingTable";
    }
  };

  setBanner = (id) => {
    //console.log("Avatar: ", id);
    this.setState({
      selected_banner: id,
    });
  };

  setBannerClass = (id) => {
    if (this.state.selected_banner === id) {
      return "read active";
    } else {
      return "read";
    }
  };

  setBannerClassMain = (id) => {
    if (this.state.selected_banner === id) {
      return "pricingTable active2";
    } else {
      return "pricingTable";
    }
  };

  setService = (id) => {
    if (this.state.selected_service.includes(id)) {
      var checked = this.state.selected_service;
      var values = checked.indexOf(id);
      checked.splice(values, 1);
      this.setState({ selected_service: checked });
    } else {
      this.setState({
        selected_service: [...this.state.selected_service, id],
      });
    }
  };

  setBundles = (id) => {
    if (this.state.selected_bundle.includes(id)) {
      var checked = this.state.selected_bundle;
      var values = checked.indexOf(id);
      checked.splice(values, 1);
      this.setState({ selected_bundle: checked });
    } else {
      this.setState({
        selected_bundle: [...this.state.selected_bundle, id],
      });
    }
  };

  setServiceClass = (id) => {
    if (this.state.selected_service.includes(id)) {
      return "read active";
    } else {
      return "read";
    }
  };

  setServiceClassMain = (id) => {
    if (this.state.selected_service.includes(id)) {
      return "pricingTable active2";
    } else {
      return "pricingTable";
    }
  };

  setServiceClassMainNew = (id) => {
    if (this.state.selected_service.includes(id)) {
      return "card card-bordered sp-plan active2";
    } else {
      return "card card-bordered sp-plan";
    }
  };

  setServiceClassNew = (id) => {
    if (this.state.selected_service.includes(id)) {
      return "btn btn-primary active3";
    } else {
      return "btn btn-dim btn-white btn-outline-primary";
    }
  };

  setBundleClassMainNew = (id) => {
    if (this.state.selected_bundle.includes(id)) {
      return "card card-bordered sp-plan active2";
    } else {
      return "card card-bordered sp-plan";
    }
  };

  setBundleClassNew = (id) => {
    if (this.state.selected_bundle.includes(id)) {
      return "btn btn-primary active3";
    } else {
      return "btn btn-dim btn-white btn-outline-primary";
    }
  };

  handleEditorChange = (updatedContent) => {
    this.setState({
      about_me: updatedContent,
    });
  };

  handleEditorChangeShort = (updatedContent) => {
    this.setState({
      about_me_short: updatedContent,
    });
  };

  handleFile = async (event) => {
    this.setState({
      picture: event.target.files[0],
      pictureName: event.target.files[0].name,
    });
  };

  calculatePercent = (percent, num) => {
    return (percent * (num / 100)).toFixed(4);
  };

  modalHide = () => {
    window.$("#modalAlert").modal("hide");
    // this.props.agreementSigned();
  };

  open_add_image = () => {
    window.$("#modalAddImage").modal("show");
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  checkNumberChar = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  checkAvailability = async () => {
    const { link_identifier } = this.state;
    if (link_identifier === "") {
      this.setState({
        errorMessage:
          "Please enter custom link ID without spaces and special characters. ",
        successMessage: "",
        link_available: "0",
        disabled: true,
        availability_button: true,
      });
    } else {
      const saveResponce = await checkAvailability(
        auth.getAccount(),
        auth.getToken(),
        link_identifier
      );
      console.log("checkAvailability: ", saveResponce.data);
      if (
        saveResponce.data.status === 403 ||
        saveResponce.data.errors === "authentication missing" ||
        saveResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        saveResponce.data.status === 404 &&
        saveResponce.data.message === "fail" &&
        saveResponce.data.note !== ""
      ) {
        // window.location.replace("/error"); 2022-07-01
        this.setState({
          errorMessage: "There is some error while checking availability.",
          successMessage: "",
          link_available: "2",
          disabled: true,
          availability_button: false,
        });
      } else if (
        saveResponce.data.status === 404 &&
        saveResponce.data.message === "not_available"
      ) {
        // window.location.replace("/error");
        this.setState({
          errorMessage: "Custom link ID is not available. Please try another.",
          successMessage: "",
          link_available: "2",
          disabled: true,
          availability_button: false,
        });
      } else if (
        saveResponce.data.status === 404 &&
        saveResponce.data.message === "restricted_link"
      ) {
        // window.location.replace("/error");
        this.setState({
          errorMessage:
            "Custom link ID is restricted. Please try another or contact suppport.",
          successMessage: "",
          link_available: "2",
          disabled: true,
          availability_button: false,
        });
      } else if (
        saveResponce.data.status === 200 &&
        saveResponce.data.message === "available"
      ) {
        this.setState({
          errorMessage: "",
          successMessage: "",
          link_available: "1",
          disabled: false,
          availability_button: false,
        });
      } else {
        this.setState({
          errorMessage: "",
          successMessage: "",
          link_available: "2",
          disabled: true,
          availability_button: false,
        });
        //window.location.replace("/error");
      }
    }
    setTimeout(() => {
      this.setState({ successMessage: "", errorMessage: "" });
    }, 5000);
  };

  getImageUpload = () => {
    this.setState({
      docErrorMessage: "",
      docSuccessMessage: "",
      add_picture: "",
      add_image_title: "",
    });
    window.$("#modalUploadImage").modal("show");
    setTimeout(() => {
      this.setState({
        formLoader: false,
      });
    }, 2000);
  };

  handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      return; // No file selected
    }

    // File type validation
    const allowedFileTypes = [".png", ".jpg", ".jpeg"];
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

    console.log("Selected file extension:", fileExtension);

    if (!allowedFileTypes.includes("." + fileExtension)) {
      console.log("Invalid file type:", fileExtension);
      this.setState({
        docErrorMessage:
          "Invalid file type. Please select a valid file format (e.g., .png, .jpg, .jpeg).",
      });
      return;
    }

    // File size validation (e.g., limit to 5MB)
    const maxSizeBytes = 5 * 1024 * 1024; // 5MB
    if (selectedFile.size > maxSizeBytes) {
      this.setState({
        docErrorMessage:
          "File size exceeds the limit (5MB). Please choose a smaller file.",
      });
      return;
    }

    const resizedImage = await this.resizeImage(selectedFile);

    // Clear any previous errors if file passes validations
    this.setState({
      add_picture: URL.createObjectURL(resizedImage),
      docErrorMessage: "",
      add_picture_name: selectedFile.name,
    });
    if (this.state.add_images_type === "logo") {
      setTimeout(() => {
        if (this.cropperRef.current && this.cropperRef.current.cropper) {
          this.cropperRef.current.cropper.zoom(-2.3);
        }
      }, 100);
    }
  };

  resizeImage = async (file) => {
    const { add_images_type } = this.state;
    const maxDimensions = {
      logo: { width: 325, height: 130 },
      image: { width: 1400, height: 980 },
      image2: { width: 549, height: 611 },
      banner: { width: 1640, height: 560 },
    };

    const maxW = maxDimensions[add_images_type].width;
    const maxH = maxDimensions[add_images_type].height;

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          let { width, height } = img;

          // Check if the image type is not "logo"
          if (add_images_type !== "logo") {
            let resizePercent = 0;

            // Calculate the aspect ratio based on the original image dimensions
            const aspectRatio = width / height;

            // Determine the target aspect ratio based on the image type
            const targetAspectRatio =
              add_images_type === "image"
                ? 1.43
                : add_images_type === "image2"
                ? 0.89
                : add_images_type === "banner"
                ? 2.93
                : 1; // Default aspect ratio if none matched

            // Adjust the dimensions to maintain the aspect ratio
            if (aspectRatio > targetAspectRatio) {
              width = maxW;
              height = Math.round(width / targetAspectRatio);
            } else {
              height = maxH;
              width = Math.round(height * targetAspectRatio);
            }

            // Draw the image onto the canvas at the adjusted dimensions
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);

            console.log(
              `Resized ${add_images_type} image to ${width}x${height}`
            );
          } else {
            // Keep the original dimensions for the logo
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0);
            console.log(
              `Kept ${add_images_type} image size: ${width}x${height}`
            );
          }

          canvas.toBlob((blob) => {
            resolve(new File([blob], file.name, { type: file.type }));
          }, file.type);
        };
      };
    });
  };

  saveNewImage = async () => {
    const { add_picture, add_picture_name, add_image_title, add_images_type } =
      this.state;

    const modalBody = document.getElementById("modalUploadImage");
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }

    if (add_image_title === "") {
      this.setState({
        docSuccessMessage: "",
        docErrorMessage: "Title is required.",
      });
    } else if (!add_picture) {
      this.setState({
        docSuccessMessage: "",
        docErrorMessage: "Please choose an image to upload.",
      });
    } else {
      const croppedBlob = await this.getCroppedBlob();
      const imageElement = this.cropperRef.current;
      const cropper = imageElement.cropper;
      const { width, height } = cropper.getCropBoxData();

      // Define maximum dimensions based on image type
      let maxWidth, maxHeight;

      if (add_images_type === "logo") {
        maxWidth = 325;
        maxHeight = 130;
      } else if (add_images_type === "image") {
        maxWidth = 1550;
        maxHeight = 840;
      } else if (add_images_type === "image2") {
        maxWidth = 549;
        maxHeight = 611;
      } else if (add_images_type === "banner") {
        maxWidth = 1640;
        maxHeight = 560;
      }

      // Check if dimensions exceed the allowed values
      if (width > maxWidth || height > maxHeight) {
        this.setState({
          docSuccessMessage: "",
          docErrorMessage: `Image dimensions exceed the allowed size for ${add_images_type}. Maximum allowed size is W: ${maxWidth} x H: ${maxHeight}.`,
        });
        return;
      }

      console.log(
        "add_picture_name: " +
          add_picture_name +
          " add_image_title: " +
          add_image_title +
          " add_images_type: " +
          add_images_type
      );

      const formData = new FormData();
      formData.append("token", process.env.REACT_APP_API_TOKEN);
      formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);

      // Append the cropped blob instead of the original image
      formData.append("file", croppedBlob);

      formData.append("image_title", add_image_title);
      formData.append("image_type", add_images_type);
      formData.append("status", 1);
      formData.append("accountno", auth.getAccount());
      formData.append("fileName", add_picture_name);

      axios
        .post(
          process.env.REACT_APP_API_URL + "uploads/upload_user_image",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "http://localhost:3000",
              "Access-Control-Allow-Credentials": true,
            },
          }
        )
        .then((res) => {
          console.log("File Upload RES ", res.data);
          if (
            res.data.status === 403 ||
            res.data.errors === "authentication missing" ||
            res.data.errors === "jwt expired"
          ) {
            auth.logout();
          } else if (res.data.status === 404 && res.data.error === "error") {
            this.setState({
              docSuccessMessage: "",
              docErrorMessage: res.data.message,
            });
          } else if (
            res.data.status === 200 &&
            res.data.message === "success"
          ) {
            this.setState({
              docSuccessMessage: "Image added successfully.",
              docErrorMessage: "",
              add_picture_name: "",
              add_picture: "",
              image_title: "",
              image_type: "",
              add_image_title: "",
            });
            setTimeout(() => {
              window.$("#modalUploadImage").modal("hide");
              this.getImageLibrary();
            }, 3000);
          } else {
            this.setState({
              docSuccessMessage: "",
              docErrorMessage: "There is some error while adding the image.",
            });
          }
        })
        .catch((error) => {
          console.error("Error uploading image: ", error);
          this.setState({
            docErrorMessage: "Error uploading image. Please try again later.",
          });
        });
    }
    setTimeout(() => {
      this.setState({
        docSuccessMessage: "",
        docErrorMessage: "",
      });
    }, 4000);
  };

  getImageLibrary = async () => {
    this.setState({
      tableLoaderListing: true,
    });
    let logo_array = [];
    let avatar_array = [];
    let banner_array = [];
    let avatar2_array = [];
    const servicesResponce = await getUserImageLibrary(
      auth.getAccount(),
      auth.getToken()
    );
    console.log("getImageLibrary: ", servicesResponce.data.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableLoaderListing: false,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      if (servicesResponce.data.data) {
        logo_array = this.groupBy(servicesResponce.data.data, "logo");
      }
      if (servicesResponce.data.data) {
        avatar_array = this.groupBy(servicesResponce.data.data, "image");
      }
      if (servicesResponce.data.data) {
        banner_array = this.groupBy(servicesResponce.data.data, "banner");
      }
      if (servicesResponce.data.data) {
        avatar2_array = this.groupBy(servicesResponce.data.data, "image2");
      }
      this.setState({
        logoData: logo_array,
        avatarData: avatar_array,
        bannerData: banner_array,
        avatarData2: avatar2_array,
        //imageData: servicesResponce.data.data,
        tableLoaderListing: false,
      });
    } else {
      this.setState({
        tableLoaderListing: false,
      });
      //window.location.replace("/error");
    }
  };

  open_service_tab = () => {};

  handleSocialLinkValidation = (name, value) => {
    let errorMessage = "";
    if (value.trim() !== "") {
      const regexMap = {
        instagram_link:
          /^(?:https:\/\/www\.instagram\.com\/(?:[a-zA-Z0-9_]{4,})?\/?)?$/,
        facebook_link:
          /^(?:https:\/\/www\.facebook\.com\/(?:[a-zA-Z0-9_.-]{4,})?\/?)?$/,
        twitter_link: /^(?:https:\/\/twitter\.com\/(?:[a-zA-Z0-9_]{4,})?\/?)?$/,
        linkedin_link:
          /^(?:https:\/\/www\.linkedin\.com\/in\/(?:[a-zA-Z0-9_.-]{4,})?\/?)?$/,
        youtube_link:
          /^(?:https:\/\/www\.youtube\.com\/channel\/(?:[a-zA-Z0-9_-]{4,})?\/?)?$/,
      };
      const isValid = regexMap[name].test(value);
      if (!isValid) {
        errorMessage = `Invalid ${name.replace("_", " ")}`;
      }
    }
    this.setState({
      [name]: value,
      [`${name}_error`]: errorMessage,
    });
  };

  handleContactDetailValidation = (name, value) => {
    let errorMessage = "";
    if (value.trim() !== "") {
      const regexMap = {
        contact_email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        //contact_phone: /^\+?\d{7,}$/,
        contact_address: /^(?=.*[a-zA-Z]).{6,}$/,
      };
      const isValid = regexMap[name].test(value);
      if (!isValid) {
        errorMessage = `Invalid ${name.replace("_", " ")}`;
      }
    }
    this.setState({
      [name]: value,
      [`${name}_error`]: errorMessage,
    });
  };

  onCrop = () => {
    const imageElement = this.cropperRef.current;
    const cropper = imageElement.cropper;
    const { width, height } = cropper.getCropBoxData();
    const { add_images_type } = this.state;

    // Define dimensions based on image type
    let minWidth, minHeight;
    let aspectRatio;

    if (add_images_type === "logo") {
      minWidth = 325;
      minHeight = 130;
      aspectRatio = 325 / 130;
    } else if (add_images_type === "image") {
      minWidth = 1400;
      minHeight = 980;
      aspectRatio = 1400 / 900;
    } else if (add_images_type === "image2") {
      minWidth = 549;
      minHeight = 611;
      aspectRatio = 549 / 611;
    } else if (add_images_type === "banner") {
      minWidth = 1640;
      minHeight = 560;
      aspectRatio = 1640 / 560;
    }

    console.log(`Aspect ratio for ${add_images_type}: ${aspectRatio}`);

    // Apply dimension restrictions
    if (width < minWidth || height < minHeight) {
      // Adjust cropping dimensions if they don't meet the minimum requirements
      cropper.setCropBoxData({
        width: Math.max(width, minWidth),
        height: Math.max(height, minHeight),
      });

      // Update dimensions directly in the DOM
      const cropSizeElement = document.getElementById("cropSize");
      if (cropSizeElement) {
        cropSizeElement.textContent = `Current Crop Size: W: ${Math.round(
          Math.max(width, minWidth)
        )} x H: ${Math.round(Math.max(height, minHeight))}`;
      }
    } else {
      // Update dimensions directly in the DOM
      const cropSizeElement = document.getElementById("cropSize");
      if (cropSizeElement) {
        cropSizeElement.textContent = `Current Crop Size: W: ${Math.round(
          width
        )} x H: ${Math.round(height)}`;
      }
    }
  };

  getCroppedBlob = () => {
    return new Promise((resolve, reject) => {
      const imageElement = this.cropperRef.current;

      if (imageElement && imageElement.cropper) {
        const cropper = imageElement.cropper;
        const croppedCanvas = cropper.getCroppedCanvas();

        if (croppedCanvas) {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          canvas.width = croppedCanvas.width;
          canvas.height = croppedCanvas.height;

          ctx.filter = `brightness(${this.state.brightness}%)`;
          ctx.drawImage(croppedCanvas, 0, 0, canvas.width, canvas.height);

          canvas.toBlob((blob) => {
            resolve(blob);
          }, "image/png");
        } else {
          reject(new Error("Failed to get cropped canvas."));
        }
      }
    });
  };

  rotateImage = (degree) => {
    const cropper = this.cropperRef.current.cropper;
    cropper.rotate(degree);
  };

  handleZoomIn = () => {
    const cropper = this.cropperRef.current.cropper;
    cropper.zoom(0.1); // Adjust zoom factor as needed
  };

  handleZoomOut = () => {
    const cropper = this.cropperRef.current.cropper;
    cropper.zoom(-0.1); // Adjust zoom factor as needed
  };

  flipBoth = () => {
    const cropper = this.cropperRef.current.cropper;
    cropper.scale(-1);
  };

  flipHorizontal = () => {
    const cropper = this.cropperRef.current.cropper;
    cropper.scale(-1, 1);
  };

  flipVertical = () => {
    const cropper = this.cropperRef.current.cropper;
    cropper.scale(1, -1);
  };

  handleResetCrop = () => {
    const imageElement = this.cropperRef.current;
    const cropper = imageElement.cropper;

    // Reset the crop box to its initial state
    cropper.reset();
    this.handleReady();
    this.setState({ brightness: 100 });

    // Apply zoom out if images_type is "logo"
    if (this.state.add_images_type === "logo") {
      setTimeout(() => {
        if (this.cropperRef.current && this.cropperRef.current.cropper) {
          this.cropperRef.current.cropper.zoom(-2.3); // Zoom out by 2.3
        }
      }, 100);
    }
  };

  handleBrightnessChange = (e) => {
    this.setState({ brightness: parseInt(e.target.value) });
  };

  toggleBrightnessRange = () => {
    this.setState((prevState) => ({
      showBrightnessRange: !prevState.showBrightnessRange,
    }));
  };

  handleReady = () => {
    const cropper = this.cropperRef.current.cropper;
    const containerData = cropper.getContainerData();
    const imageData = cropper.getImageData();

    const aspectRatio = this.calculateAspectRatio();

    let newWidth = imageData.naturalWidth * 0.5;
    let newHeight = newWidth / aspectRatio;

    const maxWidth = containerData.width;
    const maxHeight = containerData.height;

    if (newWidth > maxWidth) {
      newWidth = maxWidth;
      newHeight = newWidth / aspectRatio;
    }
    if (newHeight > maxHeight) {
      newHeight = maxHeight;
      newWidth = newHeight * aspectRatio;
    }

    let offsetTop = 0;
    let offsetLeft = 0;
    if (this.state.add_images_type === "logo") {
      offsetTop = 20;
      offsetLeft = 90;
    }

    const newLeft = (containerData.width - newWidth) / 2 - offsetLeft;
    const newTop = (containerData.height - newHeight) / 2 - offsetTop;

    cropper.setCropBoxData({
      left: newLeft,
      top: newTop,
      width: newWidth,
      height: newHeight,
    });
  };

  calculateAspectRatio = () => {
    const { add_images_type } = this.state;
    switch (add_images_type) {
      case "logo":
        return 325 / 130;
      case "image":
        return 1400 / 980;
      case "image2":
        return 549 / 611;
      default:
        return 1640 / 560;
    }
  };

  getTestimonialsLibrary = async () => {
    const response = await getSharelinkTestimonials(
      auth.getAccount(),
      auth.getToken()
    );
    if (
      response.data.status === 403 ||
      response.data.errors === "authentication missing" ||
      response.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      response.data.status === 200 &&
      response.data.message === "success"
    ) {
      this.setState({
        errorMessage: "",
        testimonials: response.data.data,
        disabled: false,
        tableLoaderListing: false,
      });
    } else if (
      response.data.status === 200 &&
      response.data.message === "no_data"
    ) {
      this.setState({
        errorMessage: "",
        testimonials: [],
        disabled: false,
        tableLoaderListing: false,
      });
    } else {
      this.setState({
        errorMessage: "There is some error while fetching the testimonials.",
        successMessage: "",
        disabled: false,
      });
      //window.location.replace("/error");
    }
  };

  handleTestimonialSelection = (id) => (event) => {
    const { selectedTestimonials } = this.state;
    if (event.target.checked) {
      this.setState({
        selectedTestimonials: [...selectedTestimonials, id],
      });
    } else {
      this.setState({
        selectedTestimonials: selectedTestimonials.filter(
          (selectedId) => selectedId !== id
        ),
      });
    }
  };

  getSelectedTestimonials = () => {
    return this.state.selectedTestimonials.join(',');
  };

  render() {
    const { add_picture, showBrightnessRange, brightness } = this.state;
    let filtered_services =
      this.state.service_type_id.length > 0
        ? this.state.serviceData.filter((service) =>
            this.state.service_type_id.includes(service.product_id)
          )
        : this.state.serviceData;
    const fetchToken = async () => {
      try {
        const response = await fetch(
          API_URL + "agents/editor_token_url_agents",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              request_type: "ckeditor-tokenUrl",
              user: auth.getAccount(),
            }),
          }
        );
        const data = await response.json();
        return data.token;
      } catch (error) {
        console.error("Failed to fetch token:", error);
        return null;
      }
    };
    return (
      <div className="nk-content " id="Services_Block">
        <div className="container-fluid" id="start_container">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}

          {/* MSA WARNING END */}
          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <Breadcrumbs aria-label="breadcrumb">
                  <Link
                    //to="#"
                    color="inherit"
                    onClick={() => this.addMenuHistory("/")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <em className="icon ni ni-home-fill"></em>
                    {"   "} Home
                  </Link>

                  <Link
                    //to="#"
                    color="inherit"
                    onClick={() => this.addMenuHistory("/sharelinks")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    {"   "} Sharelink
                  </Link>

                  <Typography color="textPrimary" className="">
                    Add New Sharelink
                  </Typography>
                </Breadcrumbs>
                {/*<h3 className="nk-block-title page-title">
                  <PageTitle name="Add New Services" />
                </h3>*/}
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-md-12">
              <div className="card card-bordered">
                <div className="card-inner">
                  {this.state.errorMessage !== "" ? (
                    <div className="example-alert">
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p>{this.state.errorMessage}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.successMessage !== "" ? (
                    <div className="example-alert">
                      <div className="alert alert-pro alert-success">
                        <div className="alert-text">
                          <h4>Success</h4>
                          <p>{this.state.successMessage}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  <br />
                  <div className="row g-4">
                    {/*<div className="card-head  col-md-12">
                      <h5 className="card-title">
                        Enter your sharelink details below
                      </h5>
                    </div>
                    <div className="form-group col-md-12">
                      <span className="form-note">
                        Specify the name of your website.
                      </span>
                  </div>*/}

                    <div className="form-group col-md-5">
                      <MutextField
                        required
                        id="title"
                        name="title"
                        type="text"
                        label="Sharelink Title"
                        inputProps={{ maxLength: 100 }}
                        defaultValue={this.state.title}
                        onChange={this.handleChange}
                        helperText="Enter the title here."
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^a-z0-9 ]/gi,
                            ""
                          );
                        }}
                        variant="outlined"
                        fullWidth
                      />
                    </div>
                    <div className="form-group col-md-5">
                      <MutextField
                        required
                        id="link_identifier"
                        name="link_identifier"
                        type="text"
                        label="Custom Link ID"
                        inputProps={{ maxLength: 100 }}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .replace(/[^a-z0-9]/gi, "")
                            .toLowerCase();
                        }}
                        defaultValue={this.state.link_identifier}
                        onChange={this.handleChange}
                        helperText="Create a custom link ID without spaces or special characters. Please ensure its availability."
                        variant="outlined"
                        fullWidth
                      />
                    </div>
                    <div className="form-group col-md-2">
                      {this.state.availability_button === false ? (
                        <a
                          className={
                            this.state.link_available === "1"
                              ? "btn btn-dim btn-outline-success"
                              : "btn btn-dim btn-outline-primary"
                          }
                          style={{ padding: "16px" }}
                          onClick={() => this.checkAvailability()}
                        >
                          {this.state.link_available === "1" ? (
                            <em className="icon ni ni-done"></em>
                          ) : null}
                          {"  "}
                          {this.state.link_available === "1"
                            ? "Available"
                            : "Check Availability"}
                        </a>
                      ) : (
                        <button
                          className="btn btn-dim btn-outline-primary"
                          style={{ marginRight: "15px" }}
                          disabled
                        >
                          <em className="icon ni ni-swap"></em> Check
                          Availability
                          <div
                            className="spinner-grow spinner-grow-sm"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </button>
                      )}
                    </div>
                    <div className="form-group col-md-5">
                      <MutextField
                        id="status"
                        name="status"
                        select
                        label="Status"
                        defaultValue={this.state.status}
                        onChange={this.handleChange}
                        SelectProps={{
                          native: true,
                        }}
                        helperText="e.g Active or Inactive"
                        variant="outlined"
                        fullWidth
                      >
                        <option key="status1" value="1">
                          Active
                        </option>
                        <option key="status0" value="0">
                          Inactive
                        </option>
                      </MutextField>
                    </div>
                    <div className="form-group col-md-5">
                      <MutextField
                        id="landing_page"
                        name="landing_page"
                        select
                        label="Landing Page"
                        defaultValue={this.state.landing_page}
                        onChange={this.handleChange}
                        SelectProps={{
                          native: true,
                        }}
                        helperText="e.g Yes will display the landing page where client can select service and register. No will not display any landing page and redirect directly to registration page."
                        variant="outlined"
                        fullWidth
                      >
                        <option key="landing_page1" value="Yes">
                          Yes
                        </option>
                        <option key="landing_page0" value="No">
                          No
                        </option>
                      </MutextField>
                    </div>

                    {this.state.landing_page === "Yes" ? (
                      <div
                        className="col-lg-12 col-md-12 col-xl-12"
                        style={{ padding: "20px", paddingTop: "0px" }}
                        id="sharelink_div"
                      >
                        <div id="accordion-2" className="accordion">
                          <div className="accordion-item">
                            <a
                              href="#"
                              className="accordion-head "
                              data-toggle="collapse"
                              data-target="#accordion-item-2-1"
                            >
                              {this.state.theme ? (
                                <span className="accordion-icon-icon accordion-icon-icon-green">
                                  <em className="icon ni ni-done"></em>
                                </span>
                              ) : (
                                <span className="accordion-icon-icon accordion-icon-icon-red">
                                  <em className="icon ni ni-dashboard"></em>
                                </span>
                              )}

                              <h6 className="title ">
                                Select Theme{" "}
                                <sup style={{ color: "red" }}>*</sup> {"  "}
                              </h6>
                              <span className="accordion-icon"></span>
                            </a>
                            <div
                              className="accordion-body collapse show"
                              id="accordion-item-2-1"
                              data-parent="#accordion-2"
                            >
                              <div className="accordion-inner">
                                <div
                                  className="col-lg-12 col-md-12 col-xl-12"
                                  style={{
                                    marginLeft: "30px",
                                  }}
                                >
                                  {this.state.tableLoaderBlockImage === true ? (
                                    tableLoaderBlockImage()
                                  ) : (
                                    <>
                                      {this.state.themesList ? (
                                        <div className="card card-bordered">
                                          <div className="card-inner">
                                            <div
                                              className="row g-4"
                                              style={{ padding: "0px" }}
                                            >
                                              {this.state.themesList.map(
                                                (themes) => (
                                                  <div
                                                    className="col-md-3 col-sm-6"
                                                    key={`theme_key${themes.id}`}
                                                  >
                                                    <div
                                                      className={this.setThemeClassMain(
                                                        themes.id
                                                      )}
                                                    >
                                                      <div className="pricingTable-header">
                                                        <img
                                                          src={`../../assets/images/${themes.theme_image}`}
                                                        />
                                                      </div>

                                                      <a
                                                        onClick={() =>
                                                          this.setTheme(
                                                            themes.id
                                                          )
                                                        }
                                                        className={this.setThemeClass(
                                                          themes.id
                                                        )}
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        {this.state.theme ===
                                                        themes.id ? (
                                                          <em className="icon ni ni-done"></em>
                                                        ) : null}
                                                        {"  "}
                                                        Choose Theme
                                                        <i className="fa fa-angle-right"></i>
                                                      </a>
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                              {/*<div
                                              className="col-md-12 col-sm-12"
                                              style={{
                                                float: "right",
                                                textAlign: "right",
                                              }}
                                            >
                                              <a
                                                href="#"
                                                onClick={() => {
                                                  this.open_service_tab();
                                                }}
                                                className="btn btn-success"
                                              >
                                                <span>Next</span>
                                                <em className="icon ni ni-arrow-right"></em>
                                              </a>
                                              </div>*/}
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="accordion-item">
                            <a
                              style={{ cursor: "pointer" }}
                              className="accordion-head collapsed"
                              data-toggle="collapse"
                              data-target="#accordion-item-2-7"
                              onClick={() => this.getServices()}
                            >
                              {this.state.selected_service.length > 0 ? (
                                <span className="accordion-icon-icon accordion-icon-icon-green">
                                  <em className="icon ni ni-done"></em>
                                </span>
                              ) : (
                                <span className="accordion-icon-icon accordion-icon-icon-red">
                                  <em className="icon ni ni-list-round"></em>
                                </span>
                              )}

                              <h6 className="title ">
                                Select Services{" "}
                                <sup style={{ color: "red" }}>*</sup> {"  "}
                              </h6>
                              <span className="accordion-icon"></span>
                            </a>
                            <div
                              className="accordion-body collapse "
                              id="accordion-item-2-7"
                              data-parent="#accordion-2"
                            >
                              <div className="accordion-inner">
                                <div
                                  className="col-lg-12 col-md-12 col-xl-12"
                                  style={{
                                    marginLeft: "30px",
                                  }}
                                >
                                  {this.state.tableLoaderBlockService ===
                                  true ? (
                                    tableLoaderBlockImage()
                                  ) : (
                                    <>
                                      {this.state.serviceData ? (
                                        <>
                                          <div className="nk-block">
                                            <div className="row g-4">
                                              <div
                                                className="col-md-12"
                                                style={{ marginBottom: "20px" }}
                                              >
                                                {/*<ul
                                                  className="nk-kycfm-control-list g-3"
                                                  style={{ width: "60%" }}
                                                >
                                                  <li className="nk-kycfm-control-item">
                                                    <input
                                                      checked={
                                                        this.state
                                                          .main_service_type ===
                                                        "service"
                                                      }
                                                      onChange={
                                                        this
                                                          .handleChangeCheckbox
                                                      }
                                                      className="nk-kycfm-control"
                                                      type="radio"
                                                      name="main_service_type"
                                                      id="service"
                                                      data-title="Select Services"
                                                      value="service"
                                                    />
                                                    <label
                                                      className="nk-kycfm-label"
                                                      htmlFor="service"
                                                    >
                                                      <span className="nk-kycfm-label-icon">
                                                        <div className="label-icon">
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 71.9904 75.9285"
                                                          >
                                                            <path
                                                              d="M27.14,23.73A15.55,15.55,0,1,0,42.57,39.4v-.12A15.5,15.5,0,0,0,27.14,23.73Zm11.42,9.72H33a25.55,25.55,0,0,0-2.21-6.53A12.89,12.89,0,0,1,38.56,33.45ZM31,39.28a26.9929,26.9929,0,0,1-.2,3.24H23.49a26.0021,26.0021,0,0,1,0-6.48H30.8A29.3354,29.3354,0,0,1,31,39.28ZM26.77,26.36h.75a21.7394,21.7394,0,0,1,2.85,7.09H23.91A21.7583,21.7583,0,0,1,26.77,26.36Zm-3.28.56a25.1381,25.1381,0,0,0-2.2,6.53H15.72a12.88,12.88,0,0,1,7.78-6.53ZM14.28,39.28A13.2013,13.2013,0,0,1,14.74,36H20.9a29.25,29.25,0,0,0,0,6.48H14.74A13.1271,13.1271,0,0,1,14.28,39.28Zm1.44,5.83h5.57a25.9082,25.9082,0,0,0,2.2,6.53A12.89,12.89,0,0,1,15.72,45.11ZM27.51,52.2h-.74a21.7372,21.7372,0,0,1-2.85-7.09h6.44A21.52,21.52,0,0,1,27.51,52.2Zm3.28-.56A25.1413,25.1413,0,0,0,33,45.11h5.57a12.84,12.84,0,0,1-7.77,6.53Zm2.59-9.12a28.4606,28.4606,0,0,0,0-6.48h6.15a11.7,11.7,0,0,1,0,6.48ZM14.29,62.6H40v2.6H14.28V62.61ZM56.57,49l1.33-5,2.48.67-1.33,5Zm-6,22.52L55.24,54l2.48.67L53.06,72.14Zm21.6-61.24-29.8-8a5.13,5.13,0,0,0-6.29,3.61h0L33.39,16H6.57A2.58,2.58,0,0,0,4,18.55V70.38A2.57,2.57,0,0,0,6.52,73L6.57,73h29.7l17.95,4.85a5.12,5.12,0,0,0,6.28-3.6v-.06L75.8,16.61a5.18,5.18,0,0,0-3.6066-6.3763L72.18,10.23ZM6.57,70.38V18.55H45.14a2.57,2.57,0,0,1,2.57,2.57V67.79a2.57,2.57,0,0,1-2.55,2.59H6.57ZM73.34,15.91,58,73.48a2.59,2.59,0,0,1-2.48,1.93,2.5192,2.5192,0,0,1-.67-.09l-9-2.42a5.15,5.15,0,0,0,4.37-5.11V47.24l1.32.36,1.33-5-2.49-.67-.16.62V21.94l2.62.71,3.05,10,2.13.57L57.88,24l3.76,1,1.65,3,1.42.39-.25-4.09,2.24-3.42-1.41-.39L62.4,22.15l-3.76-1,4.76-7.92-2.13-.57-7.6,7.14-4-1.08A5.1,5.1,0,0,0,45.14,16H36.05l2.51-9.45a2.57,2.57,0,0,1,3.12-1.84h0l29.81,8.05a2.56,2.56,0,0,1,1.56,1.21A2.65,2.65,0,0,1,73.34,15.91ZM56.57,39.59l.66-2.5,2.44.65L59,40.24Zm4.88,1.31.66-2.51,2.44.66-.65,2.5Zm-9.76-2.61.66-2.51,2.45.66-.66,2.5Z"
                                                              transform="translate(-3.9995 -2.101)"
                                                              fill="#6476ff"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </span>
                                                      <span className="nk-kycfm-label-text">
                                                        Select Services
                                                      </span>
                                                    </label>
                                                  </li>
                                                  
                                                  <li className="nk-kycfm-control-item">
                                                    <input
                                                      className="nk-kycfm-control"
                                                      type="radio"
                                                      name="main_service_type"
                                                      id="bundle"
                                                      data-title="Select Bundle"
                                                      onChange={
                                                        this
                                                          .handleChangeCheckbox
                                                      }
                                                      checked={
                                                        this.state
                                                          .main_service_type ===
                                                        "bundle"
                                                      }
                                                      value="bundle"
                                                    />
                                                    <label
                                                      className="nk-kycfm-label"
                                                      htmlFor="bundle"
                                                    >
                                                      <span className="nk-kycfm-label-icon">
                                                        <div className="label-icon">
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 76 63.0105"
                                                          >
                                                            <path
                                                              d="M76,18.79,56.53,9.56a6.19,6.19,0,0,0-5.19,0l-19.5,9.23a3.35,3.35,0,0,0-1.9,2.55H8.33A6.26,6.26,0,0,0,2,27.51v38.3A6.27,6.27,0,0,0,8.33,72H71.67A6.27,6.27,0,0,0,78,65.81v-44A3.37,3.37,0,0,0,76,18.79Zm-.56,47a3.77,3.77,0,0,1-3.8,3.71H8.33a3.77,3.77,0,0,1-3.8-3.71V27.51a3.75,3.75,0,0,1,3.7993-3.7H29.87v9.34A34.49,34.49,0,0,0,44,60.41l7.51,5.8a4.11,4.11,0,0,0,4.94,0l7.51-5.8A36.5307,36.5307,0,0,0,75.47,45.62V65.81Zm0-32.66a32.09,32.09,0,0,1-13.1,25.34l-7.51,5.8a1.5,1.5,0,0,1-1.8,0l-7.51-5.8A32.05,32.05,0,0,1,32.4,33.15V21.83A.91.91,0,0,1,33,21l19.5-9.23a3.51,3.51,0,0,1,3,0L74.92,21a.91.91,0,0,1,.55.82V33.15ZM53.87,21.43a12.47,12.47,0,0,0-12.6,12.31,12.62,12.62,0,0,0,25.23,0,12.46,12.46,0,0,0-12.6178-12.3l-.0122,0Zm0,22.14A9.83,9.83,0,1,1,64,33.78a10,10,0,0,1-10.1,9.79Zm3.31-13.22-5.32,5.19-1.18-1.15a1.29,1.29,0,0,0-1.79,0,1.2,1.2,0,0,0-.013,1.697l.013.013h0l2.08,2a1.27,1.27,0,0,0,1.79,0L59,32.09a1.22,1.22,0,0,0,0-1.72h0a1.29,1.29,0,0,0-1.8,0ZM29.87,57.16h-20a1.24,1.24,0,1,0,0,2.47h20a1.24,1.24,0,0,0,0-2.47ZM19.73,62.1H9.89a1.24,1.24,0,0,0,0,2.48h9.84a1.24,1.24,0,0,0,0-2.48Zm8.66-14.28h0L24,45.71a.36.36,0,0,1-.22-.34V44.16a1.878,1.878,0,0,1,.18-.24,10.9991,10.9991,0,0,0,1.35-2.48,2.53,2.53,0,0,0,1.23-2.16V37.51a2.61,2.61,0,0,0-.46-1.43V34a4.69,4.69,0,0,0-1.15-3.43,6.68,6.68,0,0,0-5.19-1.85,6.67,6.67,0,0,0-5.18,1.85A4.61,4.61,0,0,0,13.4,34v2a2.46,2.46,0,0,0-.46,1.43v1.78a2.49,2.49,0,0,0,.78,1.81,10.148,10.148,0,0,0,1.52,3v1.2a.36.36,0,0,1-.21.33l-4.1,2.15A4.79,4.79,0,0,0,8.33,52v1.43a1.26,1.26,0,0,0,.37.88,1.33,1.33,0,0,0,.9.36H29.87a1.31,1.31,0,0,0,.9-.36,1.26,1.26,0,0,0,.37-.88V52.11A4.76,4.76,0,0,0,28.39,47.82Zm.21,4.4H10.87V52a2.27,2.27,0,0,1,1.25-2l4.12-2.16a2.85,2.85,0,0,0,1.54-2.5V43.72a1.3,1.3,0,0,0-.3-.8,7.39,7.39,0,0,1-1.4-2.8,1.53,1.53,0,0,0-.6-.83V37.46a1.22,1.22,0,0,0,.43-.92v-2.7a2.17,2.17,0,0,1,.53-1.58,4.38,4.38,0,0,1,3.28-1,4.43,4.43,0,0,1,3.26,1,2.22,2.22,0,0,1,.55,1.6.8552.8552,0,0,0,0,.16v2.56a1.36,1.36,0,0,0,.46,1l-.08,1.86a1.23,1.23,0,0,0-.84.8,8.5819,8.5819,0,0,1-1.19,2.31c-.1.14-.22.28-.33.41a1.22,1.22,0,0,0-.33.82v1.66A2.86,2.86,0,0,0,22.86,48l4.41,2a2.28,2.28,0,0,1,1.33,2.07v.15Z"
                                                              transform="translate(-2 -8.9898)"
                                                              fill="#6476ff"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </span>
                                                      <span className="nk-kycfm-label-text">
                                                        Select Bundle
                                                      </span>
                                                    </label>
                                                    </li>
                                                </ul>*/}
                                                <Select
                                                  options={
                                                    this.state.all_service_types
                                                  }
                                                  name="selected_service_types"
                                                  placeholder="Select service types"
                                                  value={
                                                    this.state
                                                      .selected_service_types
                                                  }
                                                  autoComplete="off"
                                                  onChange={
                                                    this.handleChangeSearch
                                                  }
                                                  isClearable
                                                  isSearchable
                                                  isMulti
                                                  styles={{
                                                    control: (
                                                      baseStyles,
                                                      state
                                                    ) => ({
                                                      ...baseStyles,
                                                      lineHeight: "40px",
                                                    }),
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            {this.state.main_service_type ===
                                            "service" ? (
                                              <>
                                                {filtered_services.map(
                                                  (services, nid) => (
                                                    <div
                                                      className={this.setServiceClassMainNew(
                                                        services.id
                                                      )}
                                                      key={`nser${nid}`}
                                                    >
                                                      <div className="row no-gutters">
                                                        <div className="col-md-9">
                                                          <div className="sp-plan-info card-inner">
                                                            <div className="row gx-0 gy-3">
                                                              <div className="col-xl-10 col-sm-8">
                                                                <div className="sp-plan-name">
                                                                  <h6 className="title">
                                                                    <a
                                                                      href="#"
                                                                      onClick={(
                                                                        e
                                                                      ) => {
                                                                        e.preventDefault();
                                                                      }}
                                                                    >
                                                                      {
                                                                        services.service_title
                                                                      }{" "}
                                                                      <span className="badge badge-outline-primary">
                                                                            {services.product_title &&
                                                                            services.product_title !==
                                                                              ""
                                                                              ? `${services.product_title}`
                                                                              : ""}
                                                                          </span>
                                                                      {/*<span className="badge badge-outline-primary">
                                                                        {services.service_type ===
                                                                        "did"
                                                                          ? "DID Origination"
                                                                          : ""}
                                                                        {services.service_type ===
                                                                        "tfn"
                                                                          ? "Toll Free Origination"
                                                                          : ""}
                                                                        {services.service_type ===
                                                                        "term"
                                                                          ? "Voice Termination"
                                                                          : ""}
                                                                        {services.service_type ===
                                                                        "teams"
                                                                          ? "Microsoft Teams UCAAS"
                                                                          : ""}
                                                                        {services.service_type ===
                                                                        "ivr"
                                                                          ? "Voyce Admins"
                                                                          : ""}
                                                                        {services.service_type ===
                                                                        "tfn_term"
                                                                          ? "Toll Free Termination"
                                                                          : ""}
                                                                        {services.service_type ===
                                                                        "az_term"
                                                                          ? "International A-Z Termination"
                                                                          : ""}
                                                                        {services.service_type ===
                                                                        "live_agent"
                                                                          ? "Live Agent"
                                                                          : ""}
                                                                        {services.service_type ===
                                                                        "live_agent"
                                                                          ? "CNAM"
                                                                          : ""}
                                                                        {services.service_type ===
                                                                        "sms"
                                                                          ? "SMS Inbound / Outbound"
                                                                          : ""}
                                                                        {services.service_type ===
                                                                        "generic"
                                                                          ? "Other Services"
                                                                          : ""}
                                                                        {services.service_type ===
                                                                        "cnam"
                                                                          ? "CNAM"
                                                                          : ""}
                                                                      </span>*/}
                                                                    </a>
                                                                  </h6>
                                                                  <p>
                                                                    Type:{" "}
                                                                    <span className="text-base">
                                                                      {services.per_min_type ===
                                                                      "unmetered"
                                                                        ? "Unmetered"
                                                                        : "Metered"}
                                                                    </span>
                                                                  </p>
                                                                </div>
                                                              </div>
                                                              <div className="col-xl-2 col-sm-4"></div>
                                                            </div>
                                                          </div>
                                                          <div className="sp-plan-desc card-inner">
                                                            {services.service_type ===
                                                              "did" ||
                                                            services.service_type ===
                                                              "tfn" ||
                                                            services.service_type ===
                                                              "teams" ? (
                                                              <ul className="row gx-1">
                                                                <li className="col-6 col-lg-3">
                                                                  <p>
                                                                    <span className="text-soft">
                                                                      NRC{" "}
                                                                      <Tooltip
                                                                        title="Non-Recurring Charge – A one-time fee that is deducted on service setup."
                                                                        placement="top"
                                                                      >
                                                                        <em
                                                                          className="icon ni ni-info"
                                                                          style={{
                                                                            color:
                                                                              "#6576ff",
                                                                          }}
                                                                        ></em>
                                                                      </Tooltip>
                                                                    </span>{" "}
                                                                    $
                                                                    {services.nrc &&
                                                                    services.nrc !==
                                                                      null &&
                                                                    services.nrc !==
                                                                      ""
                                                                      ? services.nrc.toFixed(
                                                                          4
                                                                        )
                                                                      : "0.00"}
                                                                  </p>
                                                                </li>
                                                                <li className="col-6 col-lg-3">
                                                                  <p>
                                                                    <span className="text-soft">
                                                                      MRC{" "}
                                                                      <Tooltip
                                                                        title="Monthly Recurring Charge - what you pay each month for the service."
                                                                        placement="top"
                                                                      >
                                                                        <em
                                                                          className="icon ni ni-info"
                                                                          style={{
                                                                            color:
                                                                              "#6576ff",
                                                                          }}
                                                                        ></em>
                                                                      </Tooltip>
                                                                    </span>{" "}
                                                                    $
                                                                    {services.mrc &&
                                                                    services.mrc !==
                                                                      null &&
                                                                    services.mrc !==
                                                                      ""
                                                                      ? services.mrc.toFixed(
                                                                          4
                                                                        )
                                                                      : "0.00"}
                                                                  </p>
                                                                </li>
                                                                {services.main_type !==
                                                                  "ratedeck" &&
                                                                services.per_min_type !==
                                                                  "unmetered" ? (
                                                                  <li className="col-6 col-lg-3">
                                                                    <p>
                                                                      <span className="text-soft">
                                                                        Rate Per
                                                                        Minute{" "}
                                                                        <Tooltip
                                                                          title="Rate assigned per minute."
                                                                          placement="top"
                                                                        >
                                                                          <em
                                                                            className="icon ni ni-info"
                                                                            style={{
                                                                              color:
                                                                                "#6576ff",
                                                                            }}
                                                                          ></em>
                                                                        </Tooltip>
                                                                      </span>{" "}
                                                                      $
                                                                      {services.rate &&
                                                                      services.rate !==
                                                                        null &&
                                                                      services.rate !==
                                                                        ""
                                                                        ? services.rate.toFixed(
                                                                            4
                                                                          )
                                                                        : "0.00"}
                                                                    </p>
                                                                  </li>
                                                                ) : null}
                                                                {services.per_min_type ===
                                                                "unmetered" ? (
                                                                  <li className="col-6 col-lg-3">
                                                                    <p>
                                                                      <span className="text-soft">
                                                                        Rate Per
                                                                        Session{" "}
                                                                        <Tooltip
                                                                          title="Rate assigned per session."
                                                                          placement="top"
                                                                        >
                                                                          <em
                                                                            className="icon ni ni-info"
                                                                            style={{
                                                                              color:
                                                                                "#6576ff",
                                                                            }}
                                                                          ></em>
                                                                        </Tooltip>
                                                                      </span>{" "}
                                                                      $
                                                                      {services.rate &&
                                                                      services.rate !==
                                                                        null &&
                                                                      services.rate !==
                                                                        ""
                                                                        ? services.rate.toFixed(
                                                                            4
                                                                          )
                                                                        : "0.00"}
                                                                    </p>
                                                                  </li>
                                                                ) : null}
                                                                {services.main_type ===
                                                                "ratedeck" ? (
                                                                  <>
                                                                    <li className="col-6 col-lg-3">
                                                                      <p>
                                                                        <span className="text-soft">
                                                                          Effective
                                                                          Date{" "}
                                                                          <Tooltip
                                                                            title="Effective Date."
                                                                            placement="top"
                                                                          >
                                                                            <em
                                                                              className="icon ni ni-info"
                                                                              style={{
                                                                                color:
                                                                                  "#6576ff",
                                                                              }}
                                                                            ></em>
                                                                          </Tooltip>
                                                                        </span>{" "}
                                                                        {services.effective_date &&
                                                                        services.effective_date !==
                                                                          null &&
                                                                        services.effective_date !==
                                                                          "" ? (
                                                                          <>
                                                                            {this.format_date(
                                                                              services.effective_date
                                                                            )}
                                                                          </>
                                                                        ) : null}
                                                                      </p>
                                                                    </li>
                                                                  </>
                                                                ) : null}
                                                                <li className="col-6 col-lg-3">
                                                                  <p>
                                                                    <span className="text-soft">
                                                                      Cancellation
                                                                      Fee{" "}
                                                                      <Tooltip
                                                                        title="A cancellation fee is a sum of money charged to a customer who has enlisted your services."
                                                                        placement="top"
                                                                      >
                                                                        <em
                                                                          className="icon ni ni-info"
                                                                          style={{
                                                                            color:
                                                                              "#6576ff",
                                                                          }}
                                                                        ></em>
                                                                      </Tooltip>
                                                                    </span>{" "}
                                                                    $
                                                                    {services.cancellation_fee &&
                                                                    services.cancellation_fee !==
                                                                      null &&
                                                                    services.cancellation_fee !==
                                                                      ""
                                                                      ? services.cancellation_fee.toFixed(
                                                                          4
                                                                        )
                                                                      : "0.00"}
                                                                  </p>
                                                                </li>
                                                              </ul>
                                                            ) : null}
                                                            {services.service_type ===
                                                              "term" ||
                                                            services.service_type ===
                                                              "ivr" ||
                                                            services.service_type ===
                                                              "live_agent" ||
                                                            services.service_type ===
                                                              "tfn_term" ||
                                                            services.service_type ===
                                                              "az_term" ||
                                                            services.service_type ===
                                                              "generic" ? (
                                                              <ul className="row gx-1">
                                                                {services.main_type !==
                                                                  "ratedeck" &&
                                                                services.per_min_type !==
                                                                  "unmetered" ? (
                                                                  <li className="col-6 col-lg-3">
                                                                    <p>
                                                                      <span className="text-soft">
                                                                        {services.service_type ===
                                                                        "generic"
                                                                          ? "Rate"
                                                                          : "Rate Per Minute"}{" "}
                                                                        <Tooltip
                                                                          title={
                                                                            services.service_type ===
                                                                            "generic"
                                                                              ? "Rate assigned"
                                                                              : "Rate assigned per minute."
                                                                          }
                                                                          placement="top"
                                                                        >
                                                                          <em
                                                                            className="icon ni ni-info"
                                                                            style={{
                                                                              color:
                                                                                "#6576ff",
                                                                            }}
                                                                          ></em>
                                                                        </Tooltip>
                                                                      </span>{" "}
                                                                      $
                                                                      {services.rate &&
                                                                      services.rate !==
                                                                        null &&
                                                                      services.rate !==
                                                                        ""
                                                                        ? services.rate.toFixed(
                                                                            4
                                                                          )
                                                                        : "0.00"}
                                                                    </p>
                                                                  </li>
                                                                ) : null}
                                                                {services.per_min_type ===
                                                                "unmetered" ? (
                                                                  <li className="col-6 col-lg-3">
                                                                    <p>
                                                                      <span className="text-soft">
                                                                        {services.service_type ===
                                                                        "generic"
                                                                          ? "Session Rate"
                                                                          : "Rate Per Session"}{" "}
                                                                        <Tooltip
                                                                          title={
                                                                            services.service_type ===
                                                                            "generic"
                                                                              ? "Session rate assigned"
                                                                              : "Rate assigned per session"
                                                                          }
                                                                          placement="top"
                                                                        >
                                                                          <em
                                                                            className="icon ni ni-info"
                                                                            style={{
                                                                              color:
                                                                                "#6576ff",
                                                                            }}
                                                                          ></em>
                                                                        </Tooltip>
                                                                      </span>{" "}
                                                                      $
                                                                      {services.rate &&
                                                                      services.rate !==
                                                                        null &&
                                                                      services.rate !==
                                                                        ""
                                                                        ? services.rate.toFixed(
                                                                            4
                                                                          )
                                                                        : "0.00"}
                                                                    </p>
                                                                  </li>
                                                                ) : null}
                                                                {services.main_type ===
                                                                "ratedeck" ? (
                                                                  <>
                                                                    <li className="col-6 col-lg-3">
                                                                      <p>
                                                                        <span className="text-soft">
                                                                          Effective
                                                                          Date{" "}
                                                                          <Tooltip
                                                                            title="Effective Date."
                                                                            placement="top"
                                                                          >
                                                                            <em
                                                                              className="icon ni ni-info"
                                                                              style={{
                                                                                color:
                                                                                  "#6576ff",
                                                                              }}
                                                                            ></em>
                                                                          </Tooltip>
                                                                        </span>{" "}
                                                                        {services.effective_date &&
                                                                        services.effective_date !==
                                                                          null &&
                                                                        services.effective_date !==
                                                                          "" ? (
                                                                          <>
                                                                            {this.format_date(
                                                                              services.effective_date
                                                                            )}
                                                                          </>
                                                                        ) : null}
                                                                      </p>
                                                                    </li>
                                                                  </>
                                                                ) : null}
                                                                <li className="col-6 col-lg-3">
                                                                  <p>
                                                                    <span className="text-soft">
                                                                      Cancellation
                                                                      Fee{" "}
                                                                      <Tooltip
                                                                        title="A cancellation fee is a sum of money charged to a customer who has enlisted your services."
                                                                        placement="top"
                                                                      >
                                                                        <em
                                                                          className="icon ni ni-info"
                                                                          style={{
                                                                            color:
                                                                              "#6576ff",
                                                                          }}
                                                                        ></em>
                                                                      </Tooltip>
                                                                    </span>{" "}
                                                                    $
                                                                    {services.cancellation_fee &&
                                                                    services.cancellation_fee !==
                                                                      null &&
                                                                    services.cancellation_fee !==
                                                                      ""
                                                                      ? services.cancellation_fee.toFixed(
                                                                          4
                                                                        )
                                                                      : "0.00"}
                                                                  </p>
                                                                </li>
                                                              </ul>
                                                            ) : null}
                                                            {services.service_type ===
                                                            "sms" ? (
                                                              <ul className="row gx-1">
                                                                <li className="col-6 col-lg-3">
                                                                  <p>
                                                                    <span className="text-soft">
                                                                      SMS IN{" "}
                                                                      <Tooltip
                                                                        title="Price applied to SMS In Services."
                                                                        placement="top"
                                                                      >
                                                                        <em
                                                                          className="icon ni ni-info"
                                                                          style={{
                                                                            color:
                                                                              "#6576ff",
                                                                          }}
                                                                        ></em>
                                                                      </Tooltip>
                                                                    </span>{" "}
                                                                    $
                                                                    {services.sms_in &&
                                                                    services.sms_in !==
                                                                      null &&
                                                                    services.sms_in !==
                                                                      ""
                                                                      ? services.sms_in.toFixed(
                                                                          4
                                                                        )
                                                                      : "0.00"}
                                                                  </p>
                                                                </li>
                                                                <li className="col-6 col-lg-3">
                                                                  <p>
                                                                    <span className="text-soft">
                                                                      SMS OUT{" "}
                                                                      <Tooltip
                                                                        title="Price applied to SMS Out Services."
                                                                        placement="top"
                                                                      >
                                                                        <em
                                                                          className="icon ni ni-info"
                                                                          style={{
                                                                            color:
                                                                              "#6576ff",
                                                                          }}
                                                                        ></em>
                                                                      </Tooltip>
                                                                    </span>{" "}
                                                                    $
                                                                    {services.sms_out &&
                                                                    services.sms_out !==
                                                                      null &&
                                                                    services.sms_out !==
                                                                      ""
                                                                      ? services.sms_out.toFixed(
                                                                          4
                                                                        )
                                                                      : "0.00"}
                                                                  </p>
                                                                </li>
                                                                <li className="col-6 col-lg-3">
                                                                  <p>
                                                                    <span className="text-soft">
                                                                      Cancellation
                                                                      Fee{" "}
                                                                      <Tooltip
                                                                        title="A cancellation fee is a sum of money charged to a customer who has enlisted your services."
                                                                        placement="top"
                                                                      >
                                                                        <em
                                                                          className="icon ni ni-info"
                                                                          style={{
                                                                            color:
                                                                              "#6576ff",
                                                                          }}
                                                                        ></em>
                                                                      </Tooltip>
                                                                    </span>{" "}
                                                                    $
                                                                    {services.cancellation_fee &&
                                                                    services.cancellation_fee !==
                                                                      null &&
                                                                    services.cancellation_fee !==
                                                                      ""
                                                                      ? services.cancellation_fee.toFixed(
                                                                          4
                                                                        )
                                                                      : "0.00"}
                                                                  </p>
                                                                </li>
                                                              </ul>
                                                            ) : null}
                                                            {services.service_type ===
                                                            "cnam" ? (
                                                              <ul className="row gx-1">
                                                                <li className="col-6 col-lg-3">
                                                                  <p>
                                                                    <span className="text-soft">
                                                                      Update
                                                                      CNAM (MRC){" "}
                                                                      <Tooltip
                                                                        title="Price applied to Update CNAM (MRC)."
                                                                        placement="top"
                                                                      >
                                                                        <em
                                                                          className="icon ni ni-info"
                                                                          style={{
                                                                            color:
                                                                              "#6576ff",
                                                                          }}
                                                                        ></em>
                                                                      </Tooltip>
                                                                    </span>{" "}
                                                                    $
                                                                    {services.cnam_mrc &&
                                                                    services.cnam_mrc !==
                                                                      null &&
                                                                    services.cnam_mrc !==
                                                                      ""
                                                                      ? services.cnam_mrc.toFixed(
                                                                          4
                                                                        )
                                                                      : "0.00"}
                                                                  </p>
                                                                </li>
                                                                <li className="col-6 col-lg-3">
                                                                  <p>
                                                                    <span className="text-soft">
                                                                      CNAM DIP{" "}
                                                                      <Tooltip
                                                                        title="Price applied to CNAM DIP."
                                                                        placement="top"
                                                                      >
                                                                        <em
                                                                          className="icon ni ni-info"
                                                                          style={{
                                                                            color:
                                                                              "#6576ff",
                                                                          }}
                                                                        ></em>
                                                                      </Tooltip>
                                                                    </span>{" "}
                                                                    $
                                                                    {services.cnam_dip &&
                                                                    services.cnam_dip !==
                                                                      null &&
                                                                    services.cnam_dip !==
                                                                      ""
                                                                      ? services.cnam_dip.toFixed(
                                                                          4
                                                                        )
                                                                      : "0.00"}
                                                                  </p>
                                                                </li>

                                                                <li className="col-6 col-lg-3">
                                                                  <p>
                                                                    <span className="text-soft">
                                                                      Storage
                                                                      DIP{" "}
                                                                      <Tooltip
                                                                        title="Price applied to Storage DIP."
                                                                        placement="top"
                                                                      >
                                                                        <em
                                                                          className="icon ni ni-info"
                                                                          style={{
                                                                            color:
                                                                              "#6576ff",
                                                                          }}
                                                                        ></em>
                                                                      </Tooltip>
                                                                    </span>{" "}
                                                                    $
                                                                    {services.cnam_dip_local &&
                                                                    services.cnam_dip_local !==
                                                                      null &&
                                                                    services.cnam_dip_local !==
                                                                      ""
                                                                      ? services.cnam_dip_local.toFixed(
                                                                          4
                                                                        )
                                                                      : "0.00"}
                                                                  </p>
                                                                </li>

                                                                <li className="col-6 col-lg-3">
                                                                  <p>
                                                                    <span className="text-soft">
                                                                      Cancellation
                                                                      Fee{" "}
                                                                      <Tooltip
                                                                        title="A cancellation fee is a sum of money charged to a customer who has enlisted your services."
                                                                        placement="top"
                                                                      >
                                                                        <em
                                                                          className="icon ni ni-info"
                                                                          style={{
                                                                            color:
                                                                              "#6576ff",
                                                                          }}
                                                                        ></em>
                                                                      </Tooltip>
                                                                    </span>{" "}
                                                                    $
                                                                    {services.cancellation_fee &&
                                                                    services.cancellation_fee !==
                                                                      null &&
                                                                    services.cancellation_fee !==
                                                                      ""
                                                                      ? services.cancellation_fee.toFixed(
                                                                          4
                                                                        )
                                                                      : "0.00"}
                                                                  </p>
                                                                </li>
                                                              </ul>
                                                            ) : null}
                                                          </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                          <div className="sp-plan-action card-inner">
                                                            <div className="sp-plan-btn">
                                                              <a
                                                                onClick={() =>
                                                                  this.setService(
                                                                    services.id
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                className={this.setServiceClassNew(
                                                                  services.id
                                                                )}
                                                              >
                                                                <span>
                                                                  {this.state.selected_service.includes(
                                                                    services.id
                                                                  ) ? (
                                                                    <em className="icon ni ni-done"></em>
                                                                  ) : null}
                                                                  {"  "}
                                                                  CHOOSE SERVICE
                                                                </span>
                                                              </a>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                              </>
                                            ) : null}
                                            {this.state.main_service_type ===
                                            "bundle" ? (
                                              <div className="nk-block">
                                                {this.state.bundleData &&
                                                this.state.bundleData.length >
                                                  0 ? (
                                                  <>
                                                    {this.state.bundleData.map(
                                                      (bundles, bid) => (
                                                        <div
                                                          className={this.setBundleClassMainNew(
                                                            bundles.id
                                                          )}
                                                          key={`bun${bid}`}
                                                        >
                                                          <div className="row no-gutters">
                                                            <div className="col-md-9">
                                                              <div className="sp-plan-info card-inner">
                                                                <div className="row gx-0 gy-3">
                                                                  <div className="col-xl-10 col-sm-8">
                                                                    <div className="sp-plan-name">
                                                                      <h6 className="title">
                                                                        <a
                                                                          href="#"
                                                                          onClick={(
                                                                            e
                                                                          ) => {
                                                                            e.preventDefault();
                                                                          }}
                                                                        >
                                                                          {
                                                                            bundles.bundle_title
                                                                          }{" "}
                                                                        </a>
                                                                      </h6>
                                                                      <p>
                                                                        Bundle
                                                                        Services:{" "}
                                                                        <span className="text-base">
                                                                          <span className="badge badge-outline-primary">
                                                                            View
                                                                          </span>
                                                                        </span>
                                                                      </p>
                                                                    </div>
                                                                  </div>
                                                                  <div className="col-xl-2 col-sm-4"></div>
                                                                </div>
                                                              </div>
                                                              <div className="sp-plan-desc card-inner">
                                                                <ul className="row gx-1">
                                                                  <li className="col-6 col-lg-3">
                                                                    <p>
                                                                      <span className="text-soft">
                                                                        Per
                                                                        Month
                                                                        Rate
                                                                        (Charge
                                                                        Monthly){" "}
                                                                        <Tooltip
                                                                          title="Per Month Rate (Charge Monthly)"
                                                                          placement="top"
                                                                        >
                                                                          <em
                                                                            className="icon ni ni-info"
                                                                            style={{
                                                                              color:
                                                                                "#6576ff",
                                                                            }}
                                                                          ></em>
                                                                        </Tooltip>
                                                                      </span>{" "}
                                                                      $
                                                                      {bundles.per_month_rate.toFixed(
                                                                        4
                                                                      )}
                                                                    </p>
                                                                  </li>
                                                                  <li className="col-6 col-lg-3">
                                                                    <p>
                                                                      <span className="text-soft">
                                                                        Per
                                                                        Month
                                                                        Rate
                                                                        (Charge
                                                                        Yearly)
                                                                        <Tooltip
                                                                          title="Per Month Rate (Charge Yearly)"
                                                                          placement="top"
                                                                        >
                                                                          <em
                                                                            className="icon ni ni-info"
                                                                            style={{
                                                                              color:
                                                                                "#6576ff",
                                                                            }}
                                                                          ></em>
                                                                        </Tooltip>
                                                                      </span>{" "}
                                                                      $
                                                                      {bundles.per_year_rate.toFixed(
                                                                        4
                                                                      )}
                                                                    </p>
                                                                  </li>
                                                                  <li className="col-6 col-lg-3">
                                                                    <p>
                                                                      <span className="text-soft">
                                                                        Date
                                                                        Added
                                                                        <Tooltip
                                                                          title="Date Added"
                                                                          placement="top"
                                                                        >
                                                                          <em
                                                                            className="icon ni ni-info"
                                                                            style={{
                                                                              color:
                                                                                "#6576ff",
                                                                            }}
                                                                          ></em>
                                                                        </Tooltip>
                                                                      </span>{" "}
                                                                      {bundles.date_added !==
                                                                      ""
                                                                        ? this.format_date(
                                                                            bundles.date_added
                                                                          )
                                                                        : null}
                                                                    </p>
                                                                  </li>
                                                                </ul>
                                                              </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                              <div className="sp-plan-action card-inner">
                                                                <div className="sp-plan-btn">
                                                                  <a
                                                                    onClick={() =>
                                                                      this.setBundles(
                                                                        bundles.id
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                    }}
                                                                    className={this.setBundleClassNew(
                                                                      bundles.id
                                                                    )}
                                                                  >
                                                                    <span>
                                                                      {this.state.selected_bundle.includes(
                                                                        bundles.id
                                                                      ) ? (
                                                                        <em className="icon ni ni-done"></em>
                                                                      ) : null}
                                                                      {"  "}
                                                                      CHOOSE
                                                                      BUNDLE
                                                                    </span>
                                                                  </a>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      )
                                                    )}
                                                  </>
                                                ) : null}
                                              </div>
                                            ) : null}
                                            {/*PLAN BLOCK*/}

                                            {/*PLAN BLOCK*/}
                                          </div>
                                        </>
                                      ) : null}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="accordion-item">
                            <a
                              href="#"
                              className="accordion-head collapsed"
                              data-toggle="collapse"
                              data-target="#accordion-item-2-6"
                            >
                              {this.state.selected_logo &&
                              this.state.selected_avatar ? (
                                <span className="accordion-icon-icon accordion-icon-icon-green">
                                  <em className="icon ni ni-done"></em>
                                </span>
                              ) : (
                                <span className="accordion-icon-icon accordion-icon-icon-red">
                                  <em className="icon ni ni-camera"></em>
                                </span>
                              )}

                              <h6 className="title">
                                Select Logo, Avatar and Banner{" "}
                                {/* <sup style={{ color: "red" }}>*</sup> */}
                              </h6>
                              <span className="accordion-icon"></span>
                            </a>
                            <div
                              className="accordion-body collapse"
                              id="accordion-item-2-6"
                              data-parent="#accordion-2"
                            >
                              <div className="accordion-inner">
                                <div
                                  className="col-lg-12 col-md-12 col-xl-12"
                                  style={{
                                    marginLeft: "27px",
                                  }}
                                >
                                  <div class="col-md-12 d-flex justify-content-end mb-4">
                                    <a
                                      onClick={() => this.getImageUpload()}
                                      class="btn btn-dim btn-outline-primary"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <em className="icon ni ni-upload"></em>{" "}
                                      Upload Logo / Avatar / Banner
                                    </a>
                                  </div>

                                  <div className="card card-bordered">
                                    <div className="card-inner">
                                      {this.state.logoData ? (
                                        <div className="col-lg-12 ">
                                          <h6
                                            style={{
                                              marginBottom: "20px",
                                            }}
                                          >
                                            Select Logo
                                          </h6>
                                          {this.state.logoData
                                            .slice(
                                              (this.state.currentPageLogo - 1) *
                                                this.state.logosPerPage,
                                              this.state.currentPageLogo *
                                                this.state.logosPerPage
                                            )
                                            .map((images) => (
                                              <div
                                                className="col-4 d-inline-block"
                                                key={`logos${images.id}`}
                                              >
                                                <div
                                                  className={this.setLogoClassMain(
                                                    images.id
                                                  )}
                                                >
                                                  <div
                                                    className="pricingTable-header"
                                                    style={{
                                                      height: "120px",
                                                      padding: "15px",
                                                    }}
                                                  >
                                                    <img
                                                      style={{
                                                        verticalAlign: "middle",
                                                        display: "inline-block",
                                                        height: "100%",
                                                      }}
                                                      src={`${APP_LIVE_URL}files_data/sharelinks/${images.picture}`}
                                                      alt="Logo"
                                                    />
                                                  </div>
                                                  <p class="text-dark">{images.image_title}</p>
                                                  <a
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      this.setLogo(images.id)
                                                    }
                                                    className={this.setLogoClass(
                                                      images.id
                                                    )}
                                                  >
                                                    {this.state
                                                      .selected_logo ===
                                                    images.id ? (
                                                      <em className="icon ni ni-done"></em>
                                                    ) : null}{" "}
                                                    Choose Logo
                                                    <i className="fa fa-angle-right"></i>
                                                  </a>
                                                </div>
                                              </div>
                                            ))}
                                          {this.state.logoData.length >
                                            this.state.logosPerPage && (
                                            <div className="col-md-12 text-center mt-4">
                                              <span
                                                style={{
                                                  cursor:
                                                    this.state
                                                      .currentPageLogo === 1
                                                      ? "not-allowed"
                                                      : "pointer",
                                                }}
                                                onClick={() =>
                                                  this.handlePageChange(
                                                    "logo",
                                                    "prev"
                                                  )
                                                }
                                                disabled={
                                                  this.state.currentPageLogo ===
                                                  1
                                                }
                                              >
                                                <em
                                                  className="icon ni ni-back-ios"
                                                  style={{
                                                    fontSize: "24px",
                                                    marginRight: "20px",
                                                  }}
                                                ></em>
                                              </span>
                                              <span
                                                style={{
                                                  cursor:
                                                    this.state
                                                      .currentPageLogo ===
                                                    Math.ceil(
                                                      this.state.logoData
                                                        .length /
                                                        this.state.logosPerPage
                                                    )
                                                      ? "not-allowed"
                                                      : "pointer",
                                                }}
                                                onClick={() =>
                                                  this.handlePageChange(
                                                    "logo",
                                                    "next"
                                                  )
                                                }
                                                disabled={
                                                  this.state.currentPageLogo ===
                                                  Math.ceil(
                                                    this.state.logoData.length /
                                                      this.state.logosPerPage
                                                  )
                                                }
                                              >
                                                <em
                                                  className="icon ni ni-forward-ios"
                                                  style={{
                                                    fontSize: "24px",
                                                    marginLeft: "20px",
                                                  }}
                                                ></em>
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                  <div className="card card-bordered">
                                    <div className="card-inner">
                                      {this.state.avatarData ? (
                                        <div className="col-lg-12">
                                          <h6
                                            style={{
                                              marginBottom: "20px",
                                            }}
                                          >
                                            Select Avatar
                                          </h6>
                                          {this.state.avatarData
                                            .slice(
                                              (this.state.currentPageAvatar -
                                                1) *
                                                this.state.avatarsPerPage,
                                              this.state.currentPageAvatar *
                                                this.state.avatarsPerPage
                                            )
                                            .map((avatar) => (
                                              <div
                                                className="col-4 d-inline-block"
                                                key={`avatar${avatar.id}`}
                                              >
                                                <div
                                                  className={this.setAvatarClassMain(
                                                    avatar.id
                                                  )}
                                                >
                                                  <div
                                                    className="pricingTable-header"
                                                    style={{
                                                      minHeight: "150px",
                                                      padding: "15px",
                                                    }}
                                                  >
                                                    <img
                                                      style={{
                                                        height: "150px",
                                                      }}
                                                      src={`${APP_LIVE_URL}files_data/sharelinks/${avatar.picture}`}
                                                      alt="Avatar"
                                                    />
                                                  </div>
                                                  <p class="text-dark">{avatar.image_title}</p>
                                                  <a
                                                    style={{
                                                      cursor: "pointer",
                                                      paddingLeft: "15px",
                                                      paddingRight: "15px",
                                                    }}
                                                    className={this.setAvatarClass(
                                                      avatar.id
                                                    )}
                                                    onClick={() =>
                                                      this.setAvatar(avatar.id)
                                                    }
                                                  >
                                                    {this.state
                                                      .selected_avatar ===
                                                    avatar.id ? (
                                                      <em className="icon ni ni-done"></em>
                                                    ) : null}
                                                    Choose Avatar
                                                    <i className="fa fa-angle-right"></i>
                                                  </a>
                                                </div>
                                              </div>
                                            ))}
                                          {this.state.avatarData.length >
                                            this.state.avatarsPerPage && (
                                            <div className="col-md-12 text-center mt-4">
                                              <span
                                                style={{
                                                  cursor:
                                                    this.state
                                                      .currentPageAvatar === 1
                                                      ? "not-allowed"
                                                      : "pointer",
                                                }}
                                                onClick={() =>
                                                  this.handlePageChange(
                                                    "avatar",
                                                    "prev"
                                                  )
                                                }
                                                disabled={
                                                  this.state
                                                    .currentPageAvatar === 1
                                                }
                                              >
                                                <em
                                                  className="icon ni ni-back-ios"
                                                  style={{
                                                    fontSize: "24px",
                                                    marginRight: "20px",
                                                  }}
                                                ></em>
                                              </span>
                                              <span
                                                style={{
                                                  cursor:
                                                    this.state
                                                      .currentPageAvatar ===
                                                    Math.ceil(
                                                      this.state.avatarData
                                                        .length /
                                                        this.state
                                                          .avatarsPerPage
                                                    )
                                                      ? "not-allowed"
                                                      : "pointer",
                                                }}
                                                onClick={() =>
                                                  this.handlePageChange(
                                                    "avatar",
                                                    "next"
                                                  )
                                                }
                                                disabled={
                                                  this.state
                                                    .currentPageAvatar ===
                                                  Math.ceil(
                                                    this.state.avatarData
                                                      .length /
                                                      this.state.avatarsPerPage
                                                  )
                                                }
                                              >
                                                <em
                                                  className="icon ni ni-forward-ios"
                                                  style={{
                                                    fontSize: "24px",
                                                    marginLeft: "20px",
                                                  }}
                                                ></em>
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                  <div className="card card-bordered">
                                    <div className="card-inner">
                                      {this.state.avatarData2 &&
                                      this.state.avatarData2.length > 0 ? (
                                        <div className="col-lg-12">
                                          <h6
                                            style={{
                                              marginBottom: "20px",
                                            }}
                                          >
                                            Select Avatar 2
                                          </h6>
                                          {this.state.avatarData2
                                            .slice(
                                              (this.state.currentPageAvatar2 -
                                                1) *
                                                this.state.avatarsPerPage2,
                                              this.state.currentPageAvatar2 *
                                                this.state.avatarsPerPage2
                                            )
                                            .map((avatar) => (
                                              <div
                                                className="col-4 d-inline-block"
                                                key={`avatar2${avatar.id}`}
                                              >
                                                <div
                                                  className={this.setAvatar2ClassMain(
                                                    avatar.id
                                                  )}
                                                >
                                                  <div
                                                    className="pricingTable-header"
                                                    style={{
                                                      minHeight: "150px",
                                                      padding: "15px",
                                                    }}
                                                  >
                                                    <img
                                                      style={{
                                                        height: "150px",
                                                      }}
                                                      src={`${APP_LIVE_URL}files_data/sharelinks/${avatar.picture}`}
                                                      alt="Avatar 2"
                                                    />
                                                  </div>
                                                  <p class="text-dark">{avatar.image_title}</p>
                                                  <a
                                                    style={{
                                                      cursor: "pointer",
                                                      paddingLeft: "15px",
                                                      paddingRight: "15px",
                                                    }}
                                                    className={this.setAvatar2Class(
                                                      avatar.id
                                                    )}
                                                    onClick={() =>
                                                      this.setAvatar2(avatar.id)
                                                    }
                                                  >
                                                    {this.state
                                                      .selected_avatar2 ===
                                                    avatar.id ? (
                                                      <em className="icon ni ni-done"></em>
                                                    ) : null}
                                                    Choose Avatar 2
                                                    <i className="fa fa-angle-right"></i>
                                                  </a>
                                                </div>
                                              </div>
                                            ))}
                                          {this.state.avatarData2.length >
                                            this.state.avatarsPerPage2 && (
                                            <div className="col-md-12 text-center mt-4">
                                              <span
                                                style={{
                                                  cursor:
                                                    this.state
                                                      .currentPageAvatar2 === 1
                                                      ? "not-allowed"
                                                      : "pointer",
                                                }}
                                                onClick={() =>
                                                  this.handlePageChange(
                                                    "avatar2",
                                                    "prev"
                                                  )
                                                }
                                                disabled={
                                                  this.state
                                                    .currentPageAvatar2 === 1
                                                }
                                              >
                                                <em
                                                  className="icon ni ni-back-ios"
                                                  style={{
                                                    fontSize: "24px",
                                                    marginRight: "20px",
                                                  }}
                                                ></em>
                                              </span>
                                              <span
                                                style={{
                                                  cursor:
                                                    this.state
                                                      .currentPageAvatar2 ===
                                                    Math.ceil(
                                                      this.state.avatarData2
                                                        .length /
                                                        this.state
                                                          .avatarsPerPage2
                                                    )
                                                      ? "not-allowed"
                                                      : "pointer",
                                                }}
                                                onClick={() =>
                                                  this.handlePageChange(
                                                    "avatar2",
                                                    "next"
                                                  )
                                                }
                                                disabled={
                                                  this.state
                                                    .currentPageAvatar2 ===
                                                  Math.ceil(
                                                    this.state.avatarData2
                                                      .length /
                                                      this.state.avatarsPerPage2
                                                  )
                                                }
                                              >
                                                <em
                                                  className="icon ni ni-forward-ios"
                                                  style={{
                                                    fontSize: "24px",
                                                    marginLeft: "20px",
                                                  }}
                                                ></em>
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                  <div className="card card-bordered">
                                    <div className="card-inner">
                                      {this.state.bannerData ? (
                                        <div className="col-lg-12">
                                          <h6
                                            style={{
                                              marginBottom: "20px",
                                            }}
                                          >
                                            Select Banner
                                          </h6>
                                          {this.state.bannerData
                                            .slice(
                                              (this.state.currentPageBanner -
                                                1) *
                                                this.state.bannersPerPage,
                                              this.state.currentPageBanner *
                                                this.state.bannersPerPage
                                            )
                                            .map((banner) => (
                                              <div
                                                className="col-4 d-inline-block"
                                                key={`banner${banner.id}`}
                                              >
                                                <div
                                                  className={this.setBannerClassMain(
                                                    banner.id
                                                  )}
                                                >
                                                  <div
                                                    className="pricingTable-header"
                                                    style={{
                                                      height: "150px",
                                                      padding: "15px",
                                                    }}
                                                  >
                                                    <img
                                                      style={{
                                                        verticalAlign: "middle",
                                                        display: "inline-block",
                                                        height: "100%",
                                                      }}
                                                      src={`${APP_LIVE_URL}files_data/sharelinks/${banner.picture}`}
                                                      alt="Banner"
                                                    />
                                                  </div>
                                                  <p class="text-dark">{banner.image_title}</p>
                                                  <a
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      this.setBanner(banner.id)
                                                    }
                                                    className={this.setBannerClass(
                                                      banner.id
                                                    )}
                                                  >
                                                    {this.state
                                                      .selected_banner ===
                                                    banner.id ? (
                                                      <em className="icon ni ni-done"></em>
                                                    ) : null}{" "}
                                                    Choose Banner
                                                    <i className="fa fa-angle-right"></i>
                                                  </a>
                                                </div>
                                              </div>
                                            ))}
                                          {this.state.bannerData.length >
                                            this.state.bannersPerPage && (
                                            <div className="col-md-12 text-center mt-4">
                                              <span
                                                style={{
                                                  cursor:
                                                    this.state
                                                      .currentPageBanner === 1
                                                      ? "not-allowed"
                                                      : "pointer",
                                                }}
                                                onClick={() =>
                                                  this.handlePageChange(
                                                    "banner",
                                                    "prev"
                                                  )
                                                }
                                                disabled={
                                                  this.state
                                                    .currentPageBanner === 1
                                                }
                                              >
                                                <em
                                                  className="icon ni ni-back-ios"
                                                  style={{
                                                    fontSize: "24px",
                                                    marginRight: "20px",
                                                  }}
                                                ></em>
                                              </span>
                                              <span
                                                style={{
                                                  cursor:
                                                    this.state
                                                      .currentPageBanner ===
                                                    Math.ceil(
                                                      this.state.bannerData
                                                        .length /
                                                        this.state
                                                          .bannersPerPage
                                                    )
                                                      ? "not-allowed"
                                                      : "pointer",
                                                }}
                                                onClick={() =>
                                                  this.handlePageChange(
                                                    "banner",
                                                    "next"
                                                  )
                                                }
                                                disabled={
                                                  this.state
                                                    .currentPageBanner ===
                                                  Math.ceil(
                                                    this.state.bannerData
                                                      .length /
                                                      this.state.bannersPerPage
                                                  )
                                                }
                                              >
                                                <em
                                                  className="icon ni ni-forward-ios"
                                                  style={{
                                                    fontSize: "24px",
                                                    marginLeft: "20px",
                                                  }}
                                                ></em>
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="accordion-item">
                            <a
                              href="#"
                              className="accordion-head collapsed"
                              data-toggle="collapse"
                              data-target="#accordion-item-2-2"
                            >
                              {this.state.about_me_settings ? (
                                <span className="accordion-icon-icon accordion-icon-icon-green">
                                  <em className="icon ni ni-done"></em>
                                </span>
                              ) : (
                                <span className="accordion-icon-icon accordion-icon-icon-red">
                                  <em className="icon ni ni-align-justify"></em>
                                </span>
                              )}

                              <h6 className="title">
                                Select About Me Settings
                              </h6>
                              <span className="accordion-icon"></span>
                            </a>
                            <div
                              className="accordion-body collapse"
                              id="accordion-item-2-2"
                              data-parent="#accordion-2"
                            >
                              <div className="accordion-inner">
                                <div
                                  className="col-lg-12 col-md-12 col-xl-12"
                                  style={{
                                    marginLeft: "27px",
                                  }}
                                >
                                  <div className="card card-bordered">
                                    <div className="card-inner">
                                      <FormControlLabel
                                        style={{ marginBottom: "0px" }}
                                        control={
                                          <Checkbox
                                            checked={
                                              this.state.about_me_settings
                                            }
                                            onChange={this.handleChange}
                                            name="about_me_settings"
                                            id="about_me_settings"
                                            color="primary"
                                          />
                                        }
                                        label="About Me Selection"
                                      />
                                      {this.state.about_me_settings ? (
                                        <div
                                          className="row g-4"
                                          style={{ padding: "30px" }}
                                        >
                                          <div className="col-lg-12">
                                            <h6>Banner Description</h6>
                                          </div>
                                          <div className="col-lg-12">
                                            {this.state.isEditorReady ? (
                                              <>
                                                <RichTextEditorComponent
                                                  agreementContent={
                                                    this.state.about_me_short
                                                  }
                                                  onContentChange={
                                                    this.handleEditorChangeShort
                                                  }
                                                />
                                              </>
                                            ) : null}
                                          </div>
                                          <div className="col-lg-12">
                                            <h6>About Me</h6>
                                          </div>

                                          <div className="col-lg-12">
                                            <div className="form-group">
                                              {this.state.isEditorReady ? (
                                                <>
                                                  <RichTextEditorComponent
                                                    agreementContent={
                                                      this.state.about_me
                                                    }
                                                    onContentChange={
                                                      this.handleEditorChange
                                                    }
                                                  />
                                                </>
                                              ) : null}
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="accordion-item">
                            <a
                              href="#"
                              className="accordion-head collapsed"
                              data-toggle="collapse"
                              data-target="#accordion-item-2-3"
                            >
                              {this.state.contact_email_error === "" &&
                              this.state.contact_phone_error === "" &&
                              this.state.contact_address_error === "" ? (
                                <span className="accordion-icon-icon accordion-icon-icon-green">
                                  <em className="icon ni ni-done"></em>
                                </span>
                              ) : (
                                <span className="accordion-icon-icon accordion-icon-icon-red">
                                  <em className="icon ni ni-contact"></em>
                                </span>
                              )}

                              <h6 className="title">Select Contact Settings</h6>
                              <span className="accordion-icon"></span>
                            </a>
                            <div
                              className="accordion-body collapse"
                              id="accordion-item-2-3"
                              data-parent="#accordion-2"
                            >
                              <div className="accordion-inner">
                                <div
                                  className="col-lg-12 col-md-12 col-xl-12"
                                  style={{
                                    marginLeft: "27px",
                                  }}
                                >
                                  <div className="card card-bordered">
                                    <div className="card-inner">
                                      <FormControlLabel
                                        style={{ marginBottom: "0px" }}
                                        control={
                                          <Checkbox
                                            checked={
                                              this.state.contact_settings
                                            }
                                            onChange={this.handleChange}
                                            name="contact_settings"
                                            id="contact_settings"
                                            color="primary"
                                          />
                                        }
                                        label="Contact Settings"
                                      />
                                      {this.state.contact_settings ? (
                                        <div className="row g-4">
                                          <div className="col-lg-12">
                                            <h4>Contact Details</h4>
                                          </div>

                                          <div className="col-lg-12">
                                            <FormControl
                                              fullWidth
                                              variant="outlined"
                                            >
                                              <InputLabel htmlFor="contact_email">
                                                Email Address
                                              </InputLabel>
                                              <OutlinedInput
                                                id="contact_email"
                                                name="contact_email"
                                                value={this.state.contact_email}
                                                onChange={this.handleChange}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <em className="icon ni ni-emails"></em>
                                                  </InputAdornment>
                                                }
                                                labelWidth={110}
                                              />
                                              {this.state
                                                .contact_email_error && (
                                                <span
                                                  style={{ color: "#e85347" }}
                                                >
                                                  {
                                                    this.state
                                                      .contact_email_error
                                                  }
                                                </span>
                                              )}
                                            </FormControl>
                                          </div>

                                          <div className="col-lg-12">
                                            <PhoneInput
                                              className="customStyle-phone_input-add_sharelink"
                                              required
                                              defaultCountry={"us"}
                                              error={
                                                this.state.contact_phone_error
                                              }
                                              inputProps={{
                                                name: "contact_phone",
                                                id: "contact_phone",
                                                maxLength: 20,
                                                className: this.state
                                                  .contact_phone_error
                                                  ? "error-border"
                                                  : "default-border",
                                              }}
                                              dialCodePreviewStyleProps={{
                                                className: this.state
                                                  .contact_phone_error
                                                  ? "error-border"
                                                  : "default-border",
                                              }}
                                              value={this.state.contact_phone}
                                              onChange={(value) =>
                                                this.handleChange({
                                                  target: {
                                                    name: "contact_phone",
                                                    value,
                                                  },
                                                })
                                              }
                                              helperText="Enter the phone number."
                                              label="Phone Number"
                                              ref={this.phoneInputRef}
                                              onFocus={this.handleFocus}
                                            />
                                          </div>

                                          <div className="col-lg-12">
                                            <FormControl
                                              fullWidth
                                              variant="outlined"
                                            >
                                              <InputLabel htmlFor="contact_address">
                                                Address
                                              </InputLabel>
                                              <OutlinedInput
                                                id="contact_address"
                                                name="contact_address"
                                                value={
                                                  this.state.contact_address ||
                                                  ""
                                                }
                                                onChange={this.handleChange}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <em className="icon ni ni-home"></em>
                                                  </InputAdornment>
                                                }
                                                labelWidth={70}
                                              />
                                              {this.state
                                                .contact_address_error && (
                                                <span
                                                  style={{ color: "#e85347" }}
                                                >
                                                  {
                                                    this.state
                                                      .contact_address_error
                                                  }
                                                </span>
                                              )}
                                            </FormControl>
                                          </div>
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="accordion-item">
                            <a
                              href="#"
                              className="accordion-head collapsed"
                              data-toggle="collapse"
                              data-target="#accordion-item-2-4"
                            >
                              {this.state.instagram_link_error === "" &&
                              this.state.facebook_link_error === "" &&
                              this.state.twitter_link_error === "" &&
                              this.state.linkedin_link_error === "" &&
                              this.state.youtube_link_error === "" ? (
                                <span className="accordion-icon-icon accordion-icon-icon-green">
                                  <em className="icon ni ni-done"></em>
                                </span>
                              ) : (
                                <span className="accordion-icon-icon accordion-icon-icon-red">
                                  <em className="icon ni ni-link-group"></em>
                                </span>
                              )}

                              <h6 className="title">
                                Add Social Media Settings
                              </h6>
                              <span className="accordion-icon"></span>
                            </a>
                            <div
                              className="accordion-body collapse"
                              id="accordion-item-2-4"
                              data-parent="#accordion-2"
                            >
                              <div className="accordion-inner">
                                <div
                                  className="col-lg-12 col-md-12 col-xl-12"
                                  style={{
                                    marginLeft: "27px",
                                  }}
                                >
                                  <div className="card card-bordered">
                                    <div className="card-inner">
                                      <FormControlLabel
                                        style={{ marginBottom: "0px" }}
                                        control={
                                          <Checkbox
                                            checked={this.state.social_settings}
                                            onChange={this.handleChange}
                                            name="social_settings"
                                            id="social_settings"
                                            color="primary"
                                          />
                                        }
                                        label="Social Media Links"
                                      />
                                      {this.state.social_settings ? (
                                        <div className="row g-4">
                                          <div className="col-lg-12">
                                            <h4>Social Media Links</h4>
                                          </div>

                                          <div className="col-lg-12">
                                            <FormControl
                                              fullWidth
                                              variant="outlined"
                                            >
                                              <InputLabel htmlFor="instagram_link">
                                                Instagram Link
                                              </InputLabel>
                                              <OutlinedInput
                                                id="instagram_link"
                                                name="instagram_link"
                                                value={
                                                  this.state.instagram_link
                                                }
                                                onChange={this.handleChange}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <em className="icon ni ni-instagram"></em>
                                                  </InputAdornment>
                                                }
                                                labelWidth={110}
                                              />
                                              {this.state
                                                .instagram_link_error && (
                                                <span
                                                  style={{ color: "#e85347" }}
                                                >
                                                  {
                                                    this.state
                                                      .instagram_link_error
                                                  }
                                                </span>
                                              )}
                                            </FormControl>
                                          </div>

                                          <div className="col-lg-12">
                                            <FormControl
                                              fullWidth
                                              variant="outlined"
                                            >
                                              <InputLabel htmlFor="facebook_link">
                                                Facebook Link
                                              </InputLabel>
                                              <OutlinedInput
                                                id="facebook_link"
                                                name="facebook_link"
                                                value={this.state.facebook_link}
                                                onChange={this.handleChange}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <em className="icon ni ni-facebook-fill"></em>
                                                  </InputAdornment>
                                                }
                                                labelWidth={110}
                                              />
                                              {this.state
                                                .facebook_link_error && (
                                                <span
                                                  style={{ color: "#e85347" }}
                                                >
                                                  {
                                                    this.state
                                                      .facebook_link_error
                                                  }
                                                </span>
                                              )}
                                            </FormControl>
                                          </div>

                                          <div className="col-lg-12">
                                            <FormControl
                                              fullWidth
                                              variant="outlined"
                                            >
                                              <InputLabel htmlFor="twitter_link">
                                                Twitter Link
                                              </InputLabel>
                                              <OutlinedInput
                                                id="twitter_link"
                                                name="twitter_link"
                                                value={this.state.twitter_link}
                                                onChange={this.handleChange}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <em className="icon ni ni-twitter-round"></em>
                                                  </InputAdornment>
                                                }
                                                labelWidth={90}
                                              />
                                              {this.state
                                                .twitter_link_error && (
                                                <span
                                                  style={{ color: "#e85347" }}
                                                >
                                                  {
                                                    this.state
                                                      .twitter_link_error
                                                  }
                                                </span>
                                              )}
                                            </FormControl>
                                          </div>

                                          <div className="col-lg-12">
                                            <FormControl
                                              fullWidth
                                              variant="outlined"
                                            >
                                              <InputLabel htmlFor="linkedin_link">
                                                Linkedin Link
                                              </InputLabel>
                                              <OutlinedInput
                                                id="linkedin_link"
                                                name="linkedin_link"
                                                value={this.state.linkedin_link}
                                                onChange={this.handleChange}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <em className="icon ni ni-linkedin-round"></em>
                                                  </InputAdornment>
                                                }
                                                labelWidth={100}
                                              />
                                              {this.state
                                                .linkedin_link_error && (
                                                <span
                                                  style={{ color: "#e85347" }}
                                                >
                                                  {
                                                    this.state
                                                      .linkedin_link_error
                                                  }
                                                </span>
                                              )}
                                            </FormControl>
                                          </div>

                                          <div className="col-lg-12">
                                            <FormControl
                                              fullWidth
                                              variant="outlined"
                                            >
                                              <InputLabel htmlFor="youtube_link">
                                                Youtube Link
                                              </InputLabel>
                                              <OutlinedInput
                                                id="youtube_link"
                                                name="youtube_link"
                                                value={this.state.youtube_link}
                                                onChange={this.handleChange}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <em className="icon ni ni-youtube"></em>
                                                  </InputAdornment>
                                                }
                                                labelWidth={110}
                                              />
                                              {this.state
                                                .youtube_link_error && (
                                                <span
                                                  style={{ color: "#e85347" }}
                                                >
                                                  {
                                                    this.state
                                                      .youtube_link_error
                                                  }
                                                </span>
                                              )}
                                            </FormControl>
                                          </div>
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="accordion-item">
                            <a
                              href="#"
                              className="accordion-head collapsed"
                              data-toggle="collapse"
                              data-target="#accordion-item-2-5"
                            >
                              <span className="accordion-icon-icon accordion-icon-icon-green">
                                <em className="icon ni ni-done"></em>
                              </span>

                              <h6 className="title">SEO Settings</h6>
                              <span className="accordion-icon"></span>
                            </a>
                            <div
                              className="accordion-body collapse"
                              id="accordion-item-2-5"
                              data-parent="#accordion-2"
                            >
                              <div className="accordion-inner">
                                <div
                                  className="col-lg-12 col-md-12 col-xl-12"
                                  style={{
                                    marginLeft: "30px",
                                  }}
                                >
                                  <div className="card card-bordered">
                                    <div className="card-inner">
                                      <div
                                        className="row g-4"
                                        style={{ padding: "30px" }}
                                      >
                                        <div className="form-group col-md-12 col-lg-12 col-xxl-12">
                                          <MutextField
                                            id="meta_title"
                                            name="meta_title"
                                            type="text"
                                            label="Sharelink SEO Title"
                                            inputProps={{ maxLength: 100 }}
                                            defaultValue={this.state.meta_title}
                                            onChange={this.handleChange}
                                            helperText="Enter the SEO title here."
                                            variant="outlined"
                                            fullWidth
                                          />
                                        </div>
                                        <div className="col-lg-12">
                                          <h6>Meta Description</h6>
                                        </div>
                                        <div className="col-lg-12">
                                          <TextareaAutosize
                                            maxrows={4}
                                            name="meta_description"
                                            id="meta_description"
                                            aria-label=""
                                            placeholder=""
                                            defaultValue={
                                              this.state.meta_description
                                            }
                                            onChange={this.handleChange}
                                            style={{
                                              width: "100%",
                                              height: "100px",
                                              borderColor:
                                                "rgba(0, 0, 0, 0.125)",
                                              borderRadius: "4px",
                                              padding: "15px",
                                            }}
                                            variant="outlined"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="accordion-item">
                            <a
                              href="#"
                              className="accordion-head collapsed"
                              data-toggle="collapse"
                              data-target="#accordion-item-2-8"
                            >
                              <span className="accordion-icon-icon accordion-icon-icon-green">
                                <em className="icon ni ni-done"></em>
                              </span>
                              <h6 className="title">Testimonials</h6>
                              <span className="accordion-icon"></span>
                            </a>
                            <div
                              className="accordion-body collapse"
                              id="accordion-item-2-8"
                              data-parent="#accordion-2"
                            >
                              <div className="accordion-inner">
                                <div
                                  className="col-lg-12 col-md-12 col-xl-12"
                                  style={{ marginLeft: "30px" }}
                                >
                                  <div className="card card-bordered">
                                    <div className="card-inner">
                                      <div
                                        className="g-4"
                                        style={{ padding: "30px" }}
                                      >
                                        {!this.state.isAddingTestimonial && (
                                          <div className="col-lg-12 text-right">
                                            <button
                                              type="button"
                                              className="btn btn-primary"
                                              onClick={this.addTestimonial}
                                            >
                                              Add Testimonial
                                            </button>
                                          </div>
                                        )}
                                        {this.state.isAddingTestimonial && (
                                          <div className="testimonial-form">
                                            <div className="form-group col-md-12 col-lg-12 col-xxl-12">
                                              <MutextField
                                                id="testimonial_name"
                                                name="testimonial_name"
                                                type="text"
                                                label="Name"
                                                inputProps={{ maxLength: 100 }}
                                                value={
                                                  this.state.testimonial_name
                                                }
                                                onChange={(e) =>
                                                  this.setState({
                                                    testimonial_name:
                                                      e.target.value,
                                                  })
                                                }
                                                helperText="Enter the name here"
                                                variant="outlined"
                                                fullWidth
                                                maxLength={100}
                                                error={
                                                  !!this.state.testimonialErrors
                                                    .nameError
                                                }
                                              />
                                            </div>
                                            <div className="form-group col-md-12 col-lg-12 col-xxl-12">
                                              <MutextField
                                                id="testimonial_title"
                                                name="testimonial_title"
                                                type="text"
                                                label="Title"
                                                inputProps={{ maxLength: 100 }}
                                                value={
                                                  this.state.testimonial_title
                                                }
                                                onChange={(e) =>
                                                  this.setState({
                                                    testimonial_title:
                                                      e.target.value,
                                                  })
                                                }
                                                helperText="Enter the title here"
                                                variant="outlined"
                                                fullWidth
                                                maxLength={50}
                                                error={
                                                  !!this.state.testimonialErrors
                                                    .titleError
                                                }
                                              />
                                            </div>
                                            <div className="col-lg-12">
                                              <h6>Comment</h6>
                                            </div>
                                            <div className="col-lg-12">
                                              <TextareaAutosize
                                                maxRows={4}
                                                name="testimonial_comment"
                                                id="testimonial_comment"
                                                value={
                                                  this.state.testimonial_comment
                                                }
                                                onChange={(e) =>
                                                  this.setState({
                                                    testimonial_comment:
                                                      e.target.value,
                                                  })
                                                }
                                                style={{
                                                  width: "100%",
                                                  height: "100px",
                                                  borderColor:
                                                    "rgba(0, 0, 0, 0.125)",
                                                  borderRadius: "4px",
                                                  padding: "15px",
                                                }}
                                                error={
                                                  !!this.state.testimonialErrors
                                                    .commentError
                                                }
                                                maxLength={200}
                                              />
                                              {this.state.testimonialErrors
                                                .commentError && (
                                                <div style={{ color: "red" }}>
                                                  {
                                                    this.state.testimonialErrors
                                                      .commentError
                                                  }
                                                </div>
                                              )}
                                            </div>
                                            <div className="form-group col-md-12 col-lg-12 col-xxl-12 d-flex justify-content-end mt-1 mb-2">
                                              <input
                                                id="testimonial_image"
                                                type="file"
                                                accept="image/*"
                                                onChange={
                                                  this
                                                    .handleTestimonialImageChange
                                                }
                                                style={{ display: "none" }}
                                              />
                                              {this.state.selectedImageName && (
                                                <span
                                                  className="mr-2"
                                                  style={{
                                                    alignContent: "center",
                                                  }}
                                                >
                                                  <strong>
                                                    Selected File:
                                                  </strong>{" "}
                                                  {this.state.selectedImageName}
                                                </span>
                                              )}
                                              <button
                                                type="button"
                                                onClick={() =>
                                                  document
                                                    .querySelector(
                                                      'input[id="testimonial_image"]'
                                                    )
                                                    .click()
                                                }
                                                className="btn btn-dim btn-outline-primary customStyle_add_sharelink_testimonial_btns"
                                                style={{ minWidth: "" }}
                                              >
                                                <em className="icon ni ni-upload"></em>{" "}
                                                Upload Image
                                              </button>
                                            </div>
                                            <div className="col-lg-12 d-flex justify-content-end">
                                              <button
                                                type="button"
                                                className="btn btn-success customStyle_add_sharelink_testimonial_btns"
                                                onClick={this.saveTestimonial}
                                                disabled={
                                                  this.state
                                                    .save_testimonial_btn_disable
                                                }
                                              >
                                                Save Testimonial
                                              </button>
                                            </div>
                                          </div>
                                        )}

                                        {this.state.testimonials.length > 0 && (
                                          <div
                                            className="col-lg-12"
                                            style={{ marginTop: "20px" }}
                                          >
                                            <DataTable
                                              columns={
                                                this.state.columnTestimonials
                                              }
                                              tableData={this.getTableData()}
                                              title="Testimonials"
                                            />
                                            {/* <h4 className="mb-3">
                                              Saved Testimonials
                                            </h4>
                                            <ul>
                                              {this.state.testimonials.map(
                                                (testimonial, index) => (
                                                  <li
                                                    key={index}
                                                    className="mb-3"
                                                  >
                                                    <div>
                                                      <strong>
                                                        Testimonial #{index + 1}
                                                      </strong>
                                                      <em
                                                        className="ml-1 icon ni ni-edit"
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          this.editTestimonial(
                                                            index
                                                          )
                                                        }
                                                      ></em>
                                                      <em
                                                                      className="ml-1 icon ni ni-trash-empty"
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        this.deleteTestimonial(
                                                                          index
                                                                        )
                                                                      }
                                                                    ></em>
                                                    </div>
                                                    <br />
                                                    <strong>Name:</strong>{" "}
                                                    {
                                                      testimonial.testimonial_name
                                                    }
                                                    <br />
                                                    <strong>
                                                      Address:
                                                    </strong>{" "}
                                                    {
                                                      testimonial.testimonial_title
                                                    }
                                                    <br />
                                                    <strong>
                                                      Comment:
                                                    </strong>{" "}
                                                    {
                                                      testimonial.testimonial_comment
                                                    }
                                                    <br />
                                                  </li>
                                                )
                                              )}
                                            </ul> */}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    <div className="col-lg-12">
                      <div className="form-group text-right">
                        {this.state.loadingButton === true ? (
                          <button
                            className="btn btn-lg btn-primary"
                            type="button"
                            disabled
                          >
                            <span
                              className="spinner-grow spinner-grow-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span> Loading...</span>
                          </button>
                        ) : (
                          <>
                            {this.state.landing_page === "Yes" ? (
                              <button
                                type="button"
                                className="btn btn-lg btn-primary"
                                onClick={this.saveAndPreview}
                                disabled={this.state.disabled}
                                style={{ marginRight: "10px" }}
                              >
                                <em className="icon ni ni-note-add"></em>
                                {"  "}Save & Preview
                              </button>
                            ) : null}
                            {this.state.landing_page === "Yes" ? (
                              <button
                                type="button"
                                className="btn btn-lg btn-primary"
                                onClick={this.saveSharelink}
                                disabled={this.state.disabled}
                              >
                                <em className="icon ni ni-note-add"></em>
                                {"  "}Save Share Link
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-lg btn-primary"
                                onClick={this.saveSharelinkNoLanding}
                                disabled={this.state.disabled}
                              >
                                <em className="icon ni ni-note-add"></em>
                                {"  "}Save Share Link
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* DETAIL MODAL End */}
              {/** Image Upload Modal Start **/}
              <div class="modal fade" tabindex="-1" id="modalUploadImage">
                <div
                  class="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div class="modal-content">
                    <a
                      href="#"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em class="icon ni ni-cross"></em>
                    </a>
                    <div class="modal-header">
                      <h5 class="modal-title">
                        <em className="icon ni ni-upload"></em> Upload Logo /
                        Avatar
                      </h5>
                    </div>
                    <div class="modal-body">
                      {this.state.formLoader === true ? (
                        FormLoader()
                      ) : (
                        <div className="row g-4">
                          {this.state.docErrorMessage !== "" ? (
                            <div className="col-md-12 mb-3">
                              <div
                                className="example-alert example-alert-revoke"
                                style={{ marginBottom: "15px" }}
                              >
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h4>Error</h4>
                                    <p>{this.state.docErrorMessage}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.docSuccessMessage !== "" ? (
                            <div className="col-md-12 mb-3">
                              <div
                                className="example-alert example-alert-revoke"
                                style={{ marginBottom: "15px" }}
                              >
                                <div className="alert alert-pro alert-success">
                                  <div className="alert-text">
                                    <h4>Success</h4>
                                    <p>{this.state.docSuccessMessage}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="col-md-6">
                            <div className="form-group">
                              <div className="form-control-group">
                                <MutextField
                                  required
                                  id="add_image_title"
                                  name="add_image_title"
                                  type="text"
                                  label="Title"
                                  value={this.state.add_image_title}
                                  inputProps={{ maxLength: 64 }}
                                  onInput={(e) => {
                                    e.target.value = e.target.value.replace(
                                      /[^a-zA-Z0-9 -_]/gi,
                                      ""
                                    );
                                  }}
                                  helperText="Title of the image."
                                  autoFocus
                                  onChange={this.handleChange}
                                  variant="outlined"
                                  fullWidth
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <div className="form-control-group">
                                <MutextField
                                  id="add_images_type"
                                  name="add_images_type"
                                  select
                                  label="Image Type"
                                  defaultValue={this.state.add_images_type}
                                  onChange={this.handleChange}
                                  SelectProps={{
                                    native: true,
                                  }}
                                  helperText=""
                                  variant="outlined"
                                  fullWidth
                                >
                                  <option key="sets100" value="logo">
                                    Logo
                                  </option>
                                  <option key="sets101" value="image">
                                    Avatar
                                  </option>
                                  <option key="sets103" value="image2">
                                    Avatar 2
                                  </option>
                                  <option key="sets102" value="banner">
                                    Banner
                                  </option>
                                </MutextField>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <div className="form-label-group">
                                <label className="form-label">
                                  Upload File
                                  <sup> *</sup>
                                </label>
                              </div>
                              <div
                                className="form-control-group"
                                id="fileContainer"
                              >
                                <input
                                  type="file"
                                  id="add_picture"
                                  className="file-block"
                                  name="add_picture"
                                  defaultValue={this.state.add_picture}
                                  accept=".png, .jpg, .jpeg"
                                  onChange={this.handleFileChange}
                                  required
                                />
                                {add_picture && (
                                  <div style={{ margin: "15px 0 0 0" }}>
                                    <Cropper
                                      src={this.state.add_picture}
                                      style={{
                                        height: 400,
                                        width: "100%",
                                        filter: `brightness(${this.state.brightness}%)`,
                                      }}
                                      aspectRatio={this.calculateAspectRatio()}
                                      guides={true}
                                      zoomable={true}
                                      crop={this.onCrop}
                                      ref={this.cropperRef}
                                      rotatable={true}
                                      ready={this.handleReady}
                                    />
                                    <div style={{ margin: "10px 0 10px 0" }}>
                                      <p id="cropSize">No crop selected</p>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                      }}
                                    >
                                      <Tooltip title="Zoom In" placement="top">
                                        <a
                                          className="btn btn-icon btn-sm btn-primary"
                                          onClick={() => this.handleZoomIn()}
                                        >
                                          <em
                                            className="icon ni ni-zoom-in"
                                            style={{ color: "white" }}
                                          ></em>
                                        </a>
                                      </Tooltip>
                                      <Tooltip title="Zoom Out" placement="top">
                                        <a
                                          className="btn btn-icon btn-sm btn-primary"
                                          onClick={() => this.handleZoomOut()}
                                        >
                                          <em
                                            className="icon ni ni-zoom-out"
                                            style={{ color: "white" }}
                                          ></em>
                                        </a>
                                      </Tooltip>
                                      <Tooltip
                                        title="Rotate Left"
                                        placement="top"
                                      >
                                        <a
                                          className="btn btn-icon btn-sm btn-primary"
                                          onClick={() => this.rotateImage(-15)}
                                        >
                                          <em
                                            className="icon ni ni-curve-up-left"
                                            style={{ color: "white" }}
                                          ></em>
                                        </a>
                                      </Tooltip>
                                      <Tooltip
                                        title="Rotate Right"
                                        placement="top"
                                      >
                                        <a
                                          className="btn btn-icon btn-sm btn-primary"
                                          onClick={() => this.rotateImage(15)}
                                        >
                                          <em
                                            className="icon ni ni-curve-up-right"
                                            style={{ color: "white" }}
                                          ></em>
                                        </a>
                                      </Tooltip>

                                      <Tooltip
                                        title="Flip Horizontal"
                                        placement="top"
                                      >
                                        <a
                                          className="btn btn-icon btn-sm btn-primary"
                                          onClick={() => this.flipHorizontal()}
                                        >
                                          <em
                                            class="icon ni ni-swap"
                                            style={{ color: "white" }}
                                          ></em>{" "}
                                        </a>
                                      </Tooltip>

                                      <Tooltip
                                        title="Flip Vertical"
                                        placement="top"
                                      >
                                        <a
                                          className="btn btn-icon btn-sm btn-primary"
                                          onClick={() => this.flipVertical()}
                                        >
                                          <em
                                            class="icon ni ni-swap-v"
                                            style={{ color: "white" }}
                                          ></em>{" "}
                                        </a>
                                      </Tooltip>
                                      <Tooltip
                                        title="Adjust Brightness"
                                        placement="top"
                                      >
                                        <a
                                          className="btn btn-icon btn-sm btn-primary"
                                          onClick={this.toggleBrightnessRange}
                                        >
                                          <em
                                            className="icon ni ni-sun-fill"
                                            style={{ color: "white" }}
                                          ></em>
                                        </a>
                                      </Tooltip>
                                      {showBrightnessRange && (
                                        <input
                                          type="range"
                                          min="0"
                                          max="200"
                                          value={brightness}
                                          onChange={this.handleBrightnessChange}
                                          style={{
                                            width: "15%",
                                            cursor: "pointer",
                                          }}
                                        />
                                      )}
                                      <Tooltip
                                        title="Reset Crop"
                                        placement="top"
                                      >
                                        <a
                                          className="btn btn-icon btn-sm btn-danger"
                                          onClick={() =>
                                            this.handleResetCrop(15)
                                          }
                                        >
                                          <em
                                            class="icon ni ni-reload-alt"
                                            style={{ color: "white" }}
                                          ></em>
                                        </a>
                                      </Tooltip>
                                    </div>
                                    <div className="col-md-12 mt-3 p-0">
                                      <div className="example-alert">
                                        <div className="alert alert-light">
                                          <ul className="list">
                                            <li>
                                              Double-click on the image to drag
                                              it.
                                            </li>
                                            <li>
                                              Use the{" "}
                                              <b>
                                                <em class="icon ni ni-zoom-in"></em>
                                              </b>{" "}
                                              button to zoom in and the{" "}
                                              <b>
                                                <em class="icon ni ni-zoom-out"></em>
                                              </b>{" "}
                                              button to zoom out.
                                            </li>
                                            <li>
                                              Use the{" "}
                                              <b>
                                                <em className="icon ni ni-curve-up-left"></em>
                                              </b>{" "}
                                              icon to rotate left and the{" "}
                                              <b>
                                                <em className="icon ni ni-curve-up-right"></em>{" "}
                                              </b>
                                              icon to rotate right.
                                            </li>
                                            <li>
                                              Use the{" "}
                                              <b>
                                                <em className="icon ni ni-swap-v"></em>
                                              </b>{" "}
                                              icon to flip vertical and the{" "}
                                              <b>
                                                <em className="icon ni ni-swap"></em>{" "}
                                              </b>
                                              icon to flip horizontal.
                                            </li>
                                            <li>
                                              Use the{" "}
                                              <b>
                                                <em class="icon ni ni-reload-alt"></em>
                                              </b>{" "}
                                              button to reset the image and crop
                                              box.
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12 d-flex justify-content-end">
                            <button
                              type="button"
                              onClick={() => this.saveNewImage()}
                              className="btn btn-primary"
                              disabled={this.state.disabled}
                            >
                              <span>Submit</span>{" "}
                              <em className="icon ni ni-emails"></em>
                            </button>
                          </div>
                          <div className="col-md-12">
                            <div className="example-alert">
                              <div className="alert alert-light">
                                <ul className="list">
                                  <li>Accepted Formats: PNG, JPEG, JPG</li>
                                  <li>Recommended Size: 5MB</li>
                                  <li>
                                    Recommended Dimensions:
                                    <b>
                                      {" "}
                                      Logo (W:325 x H:130) - Avatar (W:1400 x
                                      H:980) - Avatar2 (W:549 x H:611) - Banner
                                      (W:1640 x H:560)
                                    </b>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/** Image Upload Modal End **/}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SharelinkSettings);
